// This file was automatically generated and should not be edited.

export * from './legacyTypes';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends {[key: string]: unknown}> = {[K in keyof T]: T[K]};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]?: Maybe<T[SubKey]>};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]: Maybe<T[SubKey]>};
export type MakeEmpty<T extends {[key: string]: unknown}, K extends keyof T> = {[_ in K]?: never};
export type Incremental<T> =
  | T
  | {[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: {input: string; output: string};
  String: {input: string; output: string};
  Boolean: {input: boolean; output: boolean};
  Int: {input: number; output: number};
  Float: {input: number; output: number};
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: {input: string; output: string};
  /** iso8601 Date-only string, e.g. 2017-12-14 */
  Date: {input: string; output: string};
  /** iso8601 formatted date & timestamp */
  DateTime: {input: string; output: string};
  /** ActionDispatch::Http::UploadedFile */
  File: {input: unknown; output: unknown};
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: {input: string; output: string};
  /** Represents untyped JSON */
  JSON: {input: unknown; output: unknown};
  /** Local time without timezone, e.g. 2:45pm would be 14:45:00 */
  LocalTime: {input: string; output: string};
  /** Integers from 0 onwards */
  NonNegativeInt: {input: number; output: number};
  /** Integers from 1 onwards */
  PositiveInt: {input: number; output: number};
  /** An ISO 8601-encoded date string with microsecond precision. */
  PreciseDateTime: {input: unknown; output: unknown};
  /** Local military time without timezone, e.g. 2:45pm would be 1445 */
  TimeWithoutZone: {input: number; output: number};
  /** iso8601 formatted date & timestamp in UTC */
  UTCTimestamp: {input: string; output: string};
  /** Universally unique identifier as defined by RFC 4122 */
  UUID: {input: string; output: string};
  join__FieldSet: {input: unknown; output: unknown};
  link__Import: {input: unknown; output: unknown};
};

/** Input type for creating a new Ach Business Bank Details */
export type AchBusinessBankDetailsCreateInput = {
  accountNumber: Scalars['String']['input'];
  address: AddressFields;
  payeeBusinessName: Scalars['String']['input'];
  registeredBusinessId: Scalars['ID']['input'];
  routingNumber: Scalars['String']['input'];
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input type for creating a new ACH Individual Bank Details */
export type AchIndividualBankDetailsCreateInput = {
  accountNumber: Scalars['String']['input'];
  address: AddressFields;
  payeeFirstName: Scalars['String']['input'];
  payeeLastName: Scalars['String']['input'];
  payeeMiddleName?: InputMaybe<Scalars['String']['input']>;
  registeredBusinessId: Scalars['ID']['input'];
  routingNumber: Scalars['String']['input'];
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Allowed values for activities category filter */
export enum ActivitiesCategoryFilterEnum {
  Adjustment = 'ADJUSTMENT',
  AppliedToInvoiceBalance = 'APPLIED_TO_INVOICE_BALANCE',
  CreditForCancelledOrder = 'CREDIT_FOR_CANCELLED_ORDER',
  CreditForModifiedOrder = 'CREDIT_FOR_MODIFIED_ORDER',
  Expired = 'EXPIRED',
  GivenForAccountCreation = 'GIVEN_FOR_ACCOUNT_CREATION',
  GivenForAppDownload = 'GIVEN_FOR_APP_DOWNLOAD',
  GivenForCatererSave = 'GIVEN_FOR_CATERER_SAVE',
  GivenForCatererSuggestion = 'GIVEN_FOR_CATERER_SUGGESTION',
  GivenForFirstMobileAppOrderPromo = 'GIVEN_FOR_FIRST_MOBILE_APP_ORDER_PROMO',
  GivenForIphoneAppRating = 'GIVEN_FOR_IPHONE_APP_RATING',
  GivenForOrderByCaterer = 'GIVEN_FOR_ORDER_BY_CATERER',
  GivenForOrderByEzcater = 'GIVEN_FOR_ORDER_BY_EZCATER',
  GivenForOrderThruReferral = 'GIVEN_FOR_ORDER_THRU_REFERRAL',
  GivenForRating = 'GIVEN_FOR_RATING',
  GivenForReferral = 'GIVEN_FOR_REFERRAL',
  GivenForReorder = 'GIVEN_FOR_REORDER',
  GivenForReview = 'GIVEN_FOR_REVIEW',
  GivenForTrustPilot = 'GIVEN_FOR_TRUST_PILOT',
  InvoiceBalanceAdjustment = 'INVOICE_BALANCE_ADJUSTMENT',
  PooledToCorpAccount = 'POOLED_TO_CORP_ACCOUNT',
  RedeemedViaCheque = 'REDEEMED_VIA_CHEQUE',
  ReviewRejected = 'REVIEW_REJECTED',
  UsedOnFood = 'USED_ON_FOOD',
  UsedOnGiftCard = 'USED_ON_GIFT_CARD',
}

/** Allowed values for ezRewards activity types */
export enum ActivityCategory {
  Adjustment = 'ADJUSTMENT',
  AppliedToInvoiceBalance = 'APPLIED_TO_INVOICE_BALANCE',
  CreditForCancelledOrder = 'CREDIT_FOR_CANCELLED_ORDER',
  CreditForModifiedOrder = 'CREDIT_FOR_MODIFIED_ORDER',
  Expired = 'EXPIRED',
  GivenForAccountCreation = 'GIVEN_FOR_ACCOUNT_CREATION',
  GivenForAppDownload = 'GIVEN_FOR_APP_DOWNLOAD',
  GivenForCatererSave = 'GIVEN_FOR_CATERER_SAVE',
  GivenForCatererSuggestion = 'GIVEN_FOR_CATERER_SUGGESTION',
  GivenForFirstMobileAppOrderPromo = 'GIVEN_FOR_FIRST_MOBILE_APP_ORDER_PROMO',
  GivenForIphoneAppRating = 'GIVEN_FOR_IPHONE_APP_RATING',
  GivenForOrderByCaterer = 'GIVEN_FOR_ORDER_BY_CATERER',
  GivenForOrderByEzcater = 'GIVEN_FOR_ORDER_BY_EZCATER',
  GivenForOrderThruReferral = 'GIVEN_FOR_ORDER_THRU_REFERRAL',
  GivenForRating = 'GIVEN_FOR_RATING',
  GivenForReferral = 'GIVEN_FOR_REFERRAL',
  GivenForReorder = 'GIVEN_FOR_REORDER',
  GivenForReview = 'GIVEN_FOR_REVIEW',
  GivenForTrustPilot = 'GIVEN_FOR_TRUST_PILOT',
  InvoiceBalanceAdjustment = 'INVOICE_BALANCE_ADJUSTMENT',
  PooledToCorpAccount = 'POOLED_TO_CORP_ACCOUNT',
  RedeemedViaCheque = 'REDEEMED_VIA_CHEQUE',
  ReviewRejected = 'REVIEW_REJECTED',
  UsedOnFood = 'USED_ON_FOOD',
  UsedOnGiftCard = 'USED_ON_GIFT_CARD',
}

/** The list of all possible activity types */
export enum ActivityTypeEnum {
  ChangeLog = 'CHANGE_LOG',
  Note = 'NOTE',
}

/** The role of the person performing an action or viewing data */
export enum ActorTypes {
  /** admin user */
  AdminUser = 'ADMIN_USER',
  /** caterer account */
  CatererAccount = 'CATERER_ACCOUNT',
  /** customer account */
  Customer = 'CUSTOMER',
  /** system */
  System = 'SYSTEM',
}

/** Input arguments required to attach a customer to a house account */
export type AddCustomerToHouseAccountInput = {
  customerId: Scalars['ID']['input'];
  houseAccountId: Scalars['ID']['input'];
};

/** Input arguments required to attach a lead to a house account */
export type AddLeadToHouseAccountInput = {
  houseAccountId: Scalars['ID']['input'];
  leadId: Scalars['ID']['input'];
};

/** Required and optional fields used to build an address */
export type AddressFields = {
  city: Scalars['String']['input'];
  deliveryInstructions?: InputMaybe<Scalars['String']['input']>;
  driverAskFor?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

/** Allowed values for address filtering */
export enum AddressFilterEnum {
  All = 'ALL',
  ConsumerAccount = 'CONSUMER_ACCOUNT',
  CorporateAccount = 'CORPORATE_ACCOUNT',
}

/** Input arguments required to create an address */
export type AddressInput = {
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

/** Allowed values for sorting a list of address objects. */
export enum AddressSortFields {
  LastUsedAt = 'LAST_USED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
}

/** Autogenerated input type of AssignDriver */
export type AssignDriverInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the delivery to be assigned to */
  deliveryId: Scalars['ID']['input'];
  /** ID of the driver to be assigned */
  driverId: Scalars['ID']['input'];
  /** The source of where the driver assignment occured */
  source?: InputMaybe<SelfAssignSource | `${SelfAssignSource}`>;
};

/** Auto bidding goal for campaign optimization */
export enum AutoBidGoalEnum {
  /** Balanced approach */
  Balanced = 'BALANCED',
  /** Conservative spend with high return */
  Efficiency = 'EFFICIENCY',
  /** Aggressive spend for higher reach */
  Visibility = 'VISIBILITY',
}

/** The available comparison operators that can be used in auto-ezDispatch rule conditions. */
export enum AutoEzDispatchRuleComparator {
  /** The attribute is equal to the rule condition. */
  EqualTo = 'EQUAL_TO',
  /** The attribute is greater than the rule condition. */
  GreaterThan = 'GREATER_THAN',
  /** The attribute is less than the rule condition. */
  LessThan = 'LESS_THAN',
}

/** Specifies the input fields to the rule for auto-requesting ezDispatch on an order. */
export type AutoEzDispatchRuleInput = {
  /** The comparison operator used to evaluate a value against the rule condition. */
  comparator?: InputMaybe<AutoEzDispatchRuleComparator | `${AutoEzDispatchRuleComparator}`>;
  /** Indicates whether the rule can be used to automatically request ezDispatch if conditions are met. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The globally-unique identifier of the rule. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The definition of the rule. This cannot be updated on an existing rule and it's only applied to new rules. */
  key?: InputMaybe<AutoEzDispatchRuleKey | `${AutoEzDispatchRuleKey}`>;
  /**
   * The schedule that controls when the rule can be applied. Not providing a
   * schedule will allow the rule to be checked at any day or any time.
   */
  schedule?: InputMaybe<AutoEzDispatchRuleScheduleInput>;
  /** The value for the rule, which is used for evaluating the rule condition. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** The possible rule definitions for auto-requesting ezDispatch. This determines how a rule functions. */
export enum AutoEzDispatchRuleKey {
  /**
   * The rule targets the distance between the order address and the address of the
   * restaurant fulfilling the order being above a certain number of miles. The
   * evaluation happens on order submission and order modification.
   */
  DeliveryDistance = 'DELIVERY_DISTANCE',
  /**
   * The rule targets the duration between the order event time and the current
   * time when the rule is evaluated. The evaluation happens on order submission
   * and order modification.
   */
  EventLeadTime = 'EVENT_LEAD_TIME',
  /**
   * The rule targets the order subtotal amount (in cents) being above or below a
   * certain dollar amount. The evaluation happens on order submission and order modification.
   */
  OrderSize = 'ORDER_SIZE',
  /**
   * The rule targets the order event time occurring within a defined schedule made
   * up of day of the week (or any day) and a start and end time. The evaluation
   * happens on order submission and order modification.
   */
  TimeOfDay = 'TIME_OF_DAY',
}

/**
 * Specifies the input fields for the rule schedule. The schedule controls which
 * datetime the rule can be applied on. It's checked against the current datetime
 * when the rule engine is evaluated. If the schedule time is outside the current
 * datetime then the rule will be skipped during evaluation.
 */
export type AutoEzDispatchRuleScheduleInput = {
  /** The day of the week the rule can be applied on. Providing `null` will be treated as "any day of the week". */
  dayOfWeek?: InputMaybe<DaysOfWeek | `${DaysOfWeek}`>;
  /**
   * The time of day the rule becomes inactive. This marks the end of the rule's
   * scheduled window. It must be a 24-hour time in `HH:mm` or `HH:mm:ss` format,
   * with leading zeros. Examples: `"09:05"`, `"09:05:00"`.
   */
  endTime: Scalars['LocalTime']['input'];
  /**
   * The time of day the rule becomes active. It must be a 24-hour time in `HH:mm`
   * or `HH:mm:ss` format, with leading zeros. Examples: `"09:05"`, `"09:05:00"`.
   */
  startTime: Scalars['LocalTime']['input'];
};

/** Specifies the input fields to the rule set for auto-requesting ezDispatch on an order. */
export type AutoEzDispatchRuleSetInput = {
  /**
   * Whether the rule set requires any or all of the rules associated to be
   * matched. When provided `true` then _any_ of the rules may match. When provided
   * `false` then _all_ of the rules must match.
   */
  disjunctiveRules?: InputMaybe<Scalars['Boolean']['input']>;
  /** The globally-unique identifier of the rule set. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The rules for auto-requesting ezDispatch that belong to the group. Any
   * existing rule set rules not included will be archived.
   */
  rules?: InputMaybe<Array<AutoEzDispatchRuleInput>>;
};

/** The status of potential auto intervention based on performance metrics */
export enum AutoInterventionStatusType {
  Active = 'ACTIVE',
  Paused = 'PAUSED',
  Unpaused = 'UNPAUSED',
  Warned = 'WARNED',
}

/** Input type for creating a Branded Marketplace promo item */
export type BrandedMarketplacePromoInput = {
  /** The UUIDs for all the caterers at which this promo is applicable. */
  catererUuids: Array<Scalars['ID']['input']>;
  discountAmount?: InputMaybe<Scalars['Int']['input']>;
  discountType: DiscountTypeEnum | `${DiscountTypeEnum}`;
  expiresOn: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderMinimum?: InputMaybe<Scalars['Int']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  weekdayOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Budget types that are available to concierge customers */
export enum Budget {
  FlatRate = 'FLAT_RATE',
  PerPerson = 'PER_PERSON',
}

/** Status of a campaign */
export enum CampaignStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

/** Allowed values for sorting campaign stores */
export enum CampaignStoreSortField {
  State = 'STATE',
  StoreNumber = 'STORE_NUMBER',
}

/** Arguments for sorting campaign stores */
export type CampaignStoreSortInput = {
  direction: SortDirection | `${SortDirection}`;
  field: CampaignStoreSortField | `${CampaignStoreSortField}`;
};

/** Autogenerated input type of CancelAllRequests */
export type CancelAllRequestsInput = {
  cancelledById?: InputMaybe<Scalars['ID']['input']>;
  cancelledByType?: InputMaybe<ActorTypes | `${ActorTypes}`>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  /** @deprecated use cancelledById instead */
  requesterId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated use cancelledByType instead */
  requesterType?: InputMaybe<ActorTypes | `${ActorTypes}`>;
};

/** Entities that can cancel an order */
export enum CancelledByEnum {
  Caterer = 'CATERER',
  Customer = 'CUSTOMER',
  Ezcater = 'EZCATER',
  TpdPartner = 'TPD_PARTNER',
}

/** Reasons an order was cancelled */
export enum CancelledByReasonEnum {
  AssignNewDoordashDriver = 'ASSIGN_NEW_DOORDASH_DRIVER',
  AttendanceChange = 'ATTENDANCE_CHANGE',
  AtDailyCapacity = 'AT_DAILY_CAPACITY',
  AtHourlyCapacity = 'AT_HOURLY_CAPACITY',
  BetterOptionFound = 'BETTER_OPTION_FOUND',
  BudgetReasons = 'BUDGET_REASONS',
  CancelledAccount = 'CANCELLED_ACCOUNT',
  CatererRequestedToCancelEzdispatchLessThan_2HoursOut = 'CATERER_REQUESTED_TO_CANCEL_EZDISPATCH_LESS_THAN_2_HOURS_OUT',
  CatererUnableToApproveLastMinModification = 'CATERER_UNABLE_TO_APPROVE_LAST_MIN_MODIFICATION',
  ChangedMind = 'CHANGED_MIND',
  ChangeFromDeliveryToTakeout = 'CHANGE_FROM_DELIVERY_TO_TAKEOUT',
  ChangeInEventDate = 'CHANGE_IN_EVENT_DATE',
  CommissionOrFeesTooHigh = 'COMMISSION_OR_FEES_TOO_HIGH',
  CustomerApprovalNotReceived = 'CUSTOMER_APPROVAL_NOT_RECEIVED',
  CustomerDoesNotWantEzDispatch = 'CUSTOMER_DOES_NOT_WANT_EZ_DISPATCH',
  DateChangeNoDupeNeeded = 'DATE_CHANGE_NO_DUPE_NEEDED',
  DidNotMeanToOrder = 'DID_NOT_MEAN_TO_ORDER',
  DistanceTooFar = 'DISTANCE_TOO_FAR',
  DoesNotOfferTakeOutOrDelivery = 'DOES_NOT_OFFER_TAKE_OUT_OR_DELIVERY',
  DoesNotRememberSigningUpForEzcater = 'DOES_NOT_REMEMBER_SIGNING_UP_FOR_EZCATER',
  DontRememberSigningUpForEzcater = 'DONT_REMEMBER_SIGNING_UP_FOR_EZCATER',
  EmergencyClosure = 'EMERGENCY_CLOSURE',
  EventCancelled = 'EVENT_CANCELLED',
  FoundDifferentCaterer = 'FOUND_DIFFERENT_CATERER',
  Fraudulent = 'FRAUDULENT',
  FraudulentCp = 'FRAUDULENT_CP',
  FraudulentCustomer = 'FRAUDULENT_CUSTOMER',
  HolidayClosure = 'HOLIDAY_CLOSURE',
  LackOfInventory = 'LACK_OF_INVENTORY',
  LeadTimeTooShortToDeliver = 'LEAD_TIME_TOO_SHORT_TO_DELIVER',
  LeadTimeTooShortToPrepare = 'LEAD_TIME_TOO_SHORT_TO_PREPARE',
  LegacyOrder = 'LEGACY_ORDER',
  LocationClosed = 'LOCATION_CLOSED',
  LowerOfferFromRestaurant = 'LOWER_OFFER_FROM_RESTAURANT',
  MenuChangeOrUpcharge = 'MENU_CHANGE_OR_UPCHARGE',
  MenuIncorrect = 'MENU_INCORRECT',
  MissingCustomerContactInformation = 'MISSING_CUSTOMER_CONTACT_INFORMATION',
  ModificationNeeded = 'MODIFICATION_NEEDED',
  NegativeEzcaterExperience = 'NEGATIVE_EZCATER_EXPERIENCE',
  NoneProvided = 'NONE_PROVIDED',
  NotEnoughDrivers = 'NOT_ENOUGH_DRIVERS',
  NotEnoughNotice = 'NOT_ENOUGH_NOTICE',
  NotEnoughNoticeToDeliver = 'NOT_ENOUGH_NOTICE_TO_DELIVER',
  NotEnoughNoticeToPrepare = 'NOT_ENOUGH_NOTICE_TO_PREPARE',
  NoDriversAvailable = 'NO_DRIVERS_AVAILABLE',
  NoDriverAvailable = 'NO_DRIVER_AVAILABLE',
  NoTip = 'NO_TIP',
  OnVacation = 'ON_VACATION',
  Other = 'OTHER',
  OutOfBusiness = 'OUT_OF_BUSINESS',
  OwnershipChanged = 'OWNERSHIP_CHANGED',
  PaymentIssues = 'PAYMENT_ISSUES',
  /** @deprecated use out_of_business instead */
  PermanentlyClosed = 'PERMANENTLY_CLOSED',
  ReasonNotListed = 'REASON_NOT_LISTED',
  ReasonNotProvided = 'REASON_NOT_PROVIDED',
  RemoveEzdispatchFromTheOrder = 'REMOVE_EZDISPATCH_FROM_THE_ORDER',
  RestaurantCannotAccommodate = 'RESTAURANT_CANNOT_ACCOMMODATE',
  SickOrIllness = 'SICK_OR_ILLNESS',
  StaffShortage = 'STAFF_SHORTAGE',
  StoreChange = 'STORE_CHANGE',
  TechnicalIssue = 'TECHNICAL_ISSUE',
  TemporarilyClosed = 'TEMPORARILY_CLOSED',
  TooBusy = 'TOO_BUSY',
  TooFar = 'TOO_FAR',
  UnableToDeliver = 'UNABLE_TO_DELIVER',
  UnableToPrepare = 'UNABLE_TO_PREPARE',
  UnforeseenCircumstances = 'UNFORESEEN_CIRCUMSTANCES',
  UnprofessionalCaterer = 'UNPROFESSIONAL_CATERER',
  UnprofessionalDriver = 'UNPROFESSIONAL_DRIVER',
  UnresponsiveCaterer = 'UNRESPONSIVE_CATERER',
  Weather = 'WEATHER',
  WrongDeliveryFee = 'WRONG_DELIVERY_FEE',
  WrongDeliveryTime = 'WRONG_DELIVERY_TIME',
  WrongHours = 'WRONG_HOURS',
  WrongMenuPrices = 'WRONG_MENU_PRICES',
  WrongMinimum = 'WRONG_MINIMUM',
  WrongOrderInfo = 'WRONG_ORDER_INFO',
  WrongStoreHours = 'WRONG_STORE_HOURS',
}

/** Allowed values for capacity limit types */
export enum CapacityLimit {
  Daily = 'DAILY',
  MealTime = 'MEAL_TIME',
}

/** Allowed values credit card type field */
export enum CardType {
  AmericanExpress = 'AMERICAN_EXPRESS',
  Blank = 'BLANK',
  Discover = 'DISCOVER',
  Master = 'MASTER',
  Visa = 'VISA',
}

/** Allowed values for filtering a list of a caterer's customers. */
export enum CatererAccountCustomersFilter {
  Happy = 'HAPPY',
  LastYearLargeOrder = 'LAST_YEAR_LARGE_ORDER',
  Sleepy = 'SLEEPY',
  TopSpenders = 'TOP_SPENDERS',
  Unhappy = 'UNHAPPY',
}

/** Allowed values for sorting a caterer account's customers data. */
export enum CatererAccountCustomersSortField {
  Email = 'EMAIL',
  FirstOrderDate = 'FIRST_ORDER_DATE',
  FirstOrderSource = 'FIRST_ORDER_SOURCE',
  Name = 'NAME',
  OrderCount = 'ORDER_COUNT',
}

/** Arguments for sorting a list of customers for a caterer account. */
export type CatererAccountCustomersSortInput = {
  direction: SortDirection | `${SortDirection}`;
  field: CatererAccountCustomersSortField | `${CatererAccountCustomersSortField}`;
};

/** Allowed values for sorting a caterer account's list of stores */
export enum CatererAccountStoreSortField {
  Address = 'ADDRESS',
  City = 'CITY',
  Nickname = 'NICKNAME',
  State = 'STATE',
  StoreNumber = 'STORE_NUMBER',
  UpdatedAt = 'UPDATED_AT',
}

/** Arguments for sorting a list of stores for a caterer account. */
export type CatererAccountStoreSortInput = {
  direction: SortDirection | `${SortDirection}`;
  field: CatererAccountStoreSortField | `${CatererAccountStoreSortField}`;
};

/** Allowed values for the app field */
export enum CatererAppIdentifier {
  AndroidCaterer = 'android_caterer',
  IosCaterer = 'ios_caterer',
}

/** Status of a caterer dispute */
export enum CatererDisputeStatus {
  /** Dispute has been approved */
  Approved = 'APPROVED',
  /** Dispute has been denied */
  Denied = 'DENIED',
  /** Dispute resulted in a partial refund */
  PartialRefund = 'PARTIAL_REFUND',
  /** Dispute is pending review */
  Pending = 'PENDING',
}

/** Additional context associated with CatererOrderActions */
export type CatererOrderActionsAdditionalContextInput = {
  fromSms?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Different types of information messages that can be displayed on an order */
export enum CatererOrderMessagesEnum {
  CancellationConfirmedByCaterer = 'CANCELLATION_CONFIRMED_BY_CATERER',
  /** @deprecated This is being deprecated without any alternative. */
  NeedsAcceptanceAfterThirdPartyDeliveryFailed = 'NEEDS_ACCEPTANCE_AFTER_THIRD_PARTY_DELIVERY_FAILED',
  Note = 'NOTE',
  PcpTrialExpired = 'PCP_TRIAL_EXPIRED',
  Rejected = 'REJECTED',
  Revised = 'REVISED',
  StandardGroupOrder = 'STANDARD_GROUP_ORDER',
  /** @deprecated This is being deprecated without any alternative. */
  ThirdPartyDeliveryRequested = 'THIRD_PARTY_DELIVERY_REQUESTED',
  /** @deprecated This is being deprecated without any alternative. Only orders fulfilled before 2020-07-21 have the potential to contain this. */
  ThirdPartyDeliveryRequestAccepted = 'THIRD_PARTY_DELIVERY_REQUEST_ACCEPTED',
}

/** Allowed values for the order sort field */
export enum CatererOrderSortField {
  EventAt = 'EVENT_AT',
}

/** Allowed values for an order's status */
export enum CatererOrderStatusEnum {
  Accepted = 'accepted',
  Cancelled = 'cancelled',
  ChangesRequested = 'changes_requested',
  Completed = 'completed',
  FoodDelivered = 'food_delivered',
  FoodPrepped = 'food_prepped',
  NeedsAcceptance = 'needs_acceptance',
  NeedsAcknowledgement = 'needs_acknowledgement',
  NeedsConfirmCancellation = 'needs_confirm_cancellation',
  NeedsConfirmModification = 'needs_confirm_modification',
  NeedsDriverAssignment = 'needs_driver_assignment',
  NeedsFoodPrep = 'needs_food_prep',
  New = 'new',
  Paid = 'paid',
  PaymentFailed = 'payment_failed',
  PendingPayment = 'pending_payment',
  Rejected = 'rejected',
  /** @deprecated This is being deprecated without any alternative. */
  ThirdPartyDeliveryRequested = 'third_party_delivery_requested',
}

/** The reasons for pausing a caterer */
export enum CatererPauseReasons {
  Cancellations = 'CANCELLATIONS',
  Compliance = 'COMPLIANCE',
  FoodNotReady = 'FOOD_NOT_READY',
  LienNegotiations = 'LIEN_NEGOTIATIONS',
  MetricsReset = 'METRICS_RESET',
  OwnershipTransfer = 'OWNERSHIP_TRANSFER',
  PaymentUpdates = 'PAYMENT_UPDATES',
  Performance = 'PERFORMANCE',
  ProlongedTempClosure = 'PROLONGED_TEMP_CLOSURE',
  Rejections = 'REJECTIONS',
  SuspectedFraud = 'SUSPECTED_FRAUD',
  SuspectedNonCommercialKitchen = 'SUSPECTED_NON_COMMERCIAL_KITCHEN',
  SuspectedOob = 'SUSPECTED_OOB',
  SuspectedOobCancelReject = 'SUSPECTED_OOB_CANCEL_REJECT',
  SuspectedOobYelp = 'SUSPECTED_OOB_YELP',
  Timeliness = 'TIMELINESS',
  VirtualBrand = 'VIRTUAL_BRAND',
}

/** The current status of a caterer report */
export enum CatererReportStatus {
  Completed = 'COMPLETED',
  Downloaded = 'DOWNLOADED',
  Processing = 'PROCESSING',
}

/** Required and optional fields used to build an address */
export type CatererSearchAddress = {
  city?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Allowed values for sorting a list of caterer objects. */
export enum CatererSortFields {
  Address = 'ADDRESS',
  City = 'CITY',
  State = 'STATE',
  StoreNickname = 'STORE_NICKNAME',
  StoreNumber = 'STORE_NUMBER',
  UpdatedAt = 'UPDATED_AT',
}

/** Input used to sort a list of caterer objects. */
export type CatererSortInput = {
  direction?: InputMaybe<SortDirection | `${SortDirection}`>;
  field?: InputMaybe<CatererSortFields | `${CatererSortFields}`>;
};

/** Allowed values for a CatererSubmittedOrderMetadatum payment method */
export enum CatererSubmittedOrderMetadatumPaymentMethod {
  CreditCard = 'CREDIT_CARD',
  HouseAccount = 'HOUSE_ACCOUNT',
  Invoice = 'INVOICE',
  InStore = 'IN_STORE',
  LineOfCredit = 'LINE_OF_CREDIT',
}

/** Allowed values for payment method type */
export enum CatererVendorPaymentTypeEnum {
  Ach = 'ACH',
  Check = 'CHECK',
  CreditCard = 'CREDIT_CARD',
  ManualCheck = 'MANUAL_CHECK',
  NoPayment = 'NO_PAYMENT',
  OneOffCheck = 'ONE_OFF_CHECK',
}

/** Allowed selections for the desired meal type while generating catering packages. (DEPRECATED) */
export enum CateringPackageMeal {
  Breakfast = 'BREAKFAST',
  Lunch = 'LUNCH',
}

/** Arguments for sorting catering partner accounts. */
export type CateringPartnerAccountSort = {
  direction: SortDirection | `${SortDirection}`;
  field: CateringPartnerAccountSortField | `${CateringPartnerAccountSortField}`;
};

/** Allowed fields for sorting catering partner accounts. */
export enum CateringPartnerAccountSortField {
  AccountStatus = 'ACCOUNT_STATUS',
  AccountType = 'ACCOUNT_TYPE',
  Email = 'EMAIL',
  Name = 'NAME',
}

/** Allowed fields for filtering catering partner accounts by their portal status. */
export enum CateringPartnerAccountStatusFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  AllActiveAndInvited = 'ALL_ACTIVE_AND_INVITED',
  Inactive = 'INACTIVE',
  Invited = 'INVITED',
  NonDeactivated = 'NON_DEACTIVATED',
  NoAccount = 'NO_ACCOUNT',
}

/** Assignable attributes for a store group associated with a catering partner account. */
export type CateringPartnerStoreGroupInput = {
  name: Scalars['String']['input'];
};

/** Autogenerated input type of ChangeDriver */
export type ChangeDriverInput = {
  /** ID of the driver to be assigned */
  assignDriverId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the delivery to be assigned to */
  deliveryId: Scalars['ID']['input'];
  /** ID of the driver to be unassigned */
  unassignDriverId: Scalars['ID']['input'];
};

/** The list of events logged in the change log */
export enum ChangeLogEventTypeEnum {
  Create = 'create',
  Destroy = 'destroy',
  LeadConvertedToCustomer = 'lead_converted_to_customer',
  Update = 'update',
}

/** Allowed values for the channel name field */
export enum ChannelNameEnum {
  ClubSoda = 'CLUB_SODA',
  DirectEntry = 'DIRECT_ENTRY',
  EzOrdering = 'EZ_ORDERING',
  Give = 'GIVE',
  Marketplace = 'MARKETPLACE',
}

/** Input type for creating a new Check BusinessBank Details */
export type CheckBusinessBankDetailsCreateInput = {
  address: AddressFields;
  payeeBusinessName: Scalars['String']['input'];
  registeredBusinessId: Scalars['ID']['input'];
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input type for creating a new Check for an Individual Bank Details */
export type CheckIndividualBankDetailsCreateInput = {
  address: AddressFields;
  payeeFirstName: Scalars['String']['input'];
  payeeLastName: Scalars['String']['input'];
  payeeMiddleName?: InputMaybe<Scalars['String']['input']>;
  registeredBusinessId: Scalars['ID']['input'];
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Available communication roles that can be assigned to contacts */
export enum CommunicationRoleEnum {
  /** Compensation Contact */
  CompensationContact = 'COMPENSATION_CONTACT',
}

export enum ComparatorTargetEnum {
  NearbyRestaurants = 'NEARBY_RESTAURANTS',
  PriorYear = 'PRIOR_YEAR',
}

/** Autogenerated input type of CompleteMessageThread */
export type CompleteMessageThreadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  completedById: Scalars['ID']['input'];
  completedByType: ActorTypes | `${ActorTypes}`;
  orderInfo: OrderInfoInput;
};

/** Add-ons that are available to concierge customers */
export enum ConciergeAddOn {
  Desserts = 'DESSERTS',
  Drinks = 'DRINKS',
  Ice = 'ICE',
  Tableware = 'TABLEWARE',
}

/** How likely it is that a user has a concur account and why */
export enum ConcurLikeliness {
  CorpAccount = 'CORP_ACCOUNT',
  Definite = 'DEFINITE',
  EmailDomain = 'EMAIL_DOMAIN',
  Unknown = 'UNKNOWN',
}

/** Allowed Concur order statuses */
export enum ConcurOrderStatus {
  Available = 'AVAILABLE',
  Failed = 'FAILED',
  PaidWithCreditLine = 'PAID_WITH_CREDIT_LINE',
  Pending = 'PENDING',
  Sent = 'SENT',
  TooOld = 'TOO_OLD',
}

/** The types of customer message codes that can appear on a consumer cart */
export enum ConsumerCartCustomerMessageCode {
  CatererClosed = 'CATERER_CLOSED',
  CatererClosedForVacation = 'CATERER_CLOSED_FOR_VACATION',
  CatererDeliveryOnly = 'CATERER_DELIVERY_ONLY',
  CatererNotInStore = 'CATERER_NOT_IN_STORE',
  CatererNoBusinessOrders = 'CATERER_NO_BUSINESS_ORDERS',
  CatererNoResidentialOrders = 'CATERER_NO_RESIDENTIAL_ORDERS',
  CatererOutOfRange = 'CATERER_OUT_OF_RANGE',
  CatererTakeoutOnly = 'CATERER_TAKEOUT_ONLY',
  CreditCardMissingZipCode = 'CREDIT_CARD_MISSING_ZIP_CODE',
  EarlyDeliveryTime = 'EARLY_DELIVERY_TIME',
  ImpreciseOrderAddress = 'IMPRECISE_ORDER_ADDRESS',
  InvalidOrderAddress = 'INVALID_ORDER_ADDRESS',
  ItemsPastCutoff = 'ITEMS_PAST_CUTOFF',
  NoCaterer = 'NO_CATERER',
  NoOrderEventDateTime = 'NO_ORDER_EVENT_DATE_TIME',
  NoPaymentMethod = 'NO_PAYMENT_METHOD',
  NoShortNoticeChoice = 'NO_SHORT_NOTICE_CHOICE',
  OrderEventDatePassed = 'ORDER_EVENT_DATE_PASSED',
  OrderEventPastCutoff = 'ORDER_EVENT_PAST_CUTOFF',
  OrderIsModification = 'ORDER_IS_MODIFICATION',
  OrderItemsNotAvailable = 'ORDER_ITEMS_NOT_AVAILABLE',
  OrderMayBeDuplicate = 'ORDER_MAY_BE_DUPLICATE',
  OrderOverCorpSpendingLimit = 'ORDER_OVER_CORP_SPENDING_LIMIT',
  OrderOverGroupBudget = 'ORDER_OVER_GROUP_BUDGET',
  OrderUnderMinimum = 'ORDER_UNDER_MINIMUM',
}

/** The available ezCater cart experiences */
export enum ConsumerCartExperience {
  EzOrdering = 'EZ_ORDERING',
  Marketplace = 'MARKETPLACE',
}

/** Allowed values for sorting a list of consumer cart objects. */
export enum ConsumerCartSortFields {
  CreatedAt = 'CREATED_AT',
}

/** The stage of ConsumerCart process. */
export enum ConsumerCartStage {
  Checkout = 'CHECKOUT',
  Menu = 'MENU',
}

/**
 * Payment methods that can are accepted to pay for an Order. Some Orders will only be payable with
 * specific payment methods.
 */
export enum ConsumerPaymentMethodsEnum {
  CorpCreditLine = 'CORP_CREDIT_LINE',
  CreditCard = 'CREDIT_CARD',
  EzRewards = 'EZ_REWARDS',
}

/** Allowed values for a Contact's account status */
export enum ContactAccountStatusEnum {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  NeedsActivation = 'NEEDS_ACTIVATION',
  NoAccount = 'NO_ACCOUNT',
  PasswordReset = 'PASSWORD_RESET',
}

/** Input used to update a contact's preferences for a particular notification */
export type ContactNotificationPreferenceInput = {
  type: ContactNotificationTypes | `${ContactNotificationTypes}`;
  value: Scalars['Boolean']['input'];
};

/** The types of notifications we send to catering partners. */
export enum ContactNotificationTypes {
  BillingOnEmail1 = 'BILLING_ON_EMAIL1',
  BillingOnEmail2 = 'BILLING_ON_EMAIL2',
  BillingOnEmail3 = 'BILLING_ON_EMAIL3',
  CatererAcceptOnPhone1 = 'CATERER_ACCEPT_ON_PHONE1',
  CatererAcceptOnPhone2 = 'CATERER_ACCEPT_ON_PHONE2',
  CatererAcceptOnPhone3 = 'CATERER_ACCEPT_ON_PHONE3',
  DeliveryReminderOnEmail1 = 'DELIVERY_REMINDER_ON_EMAIL1',
  DeliveryReminderOnEmail2 = 'DELIVERY_REMINDER_ON_EMAIL2',
  DeliveryReminderOnEmail3 = 'DELIVERY_REMINDER_ON_EMAIL3',
  FoodPrepOnPhone1 = 'FOOD_PREP_ON_PHONE1',
  FoodPrepOnPhone2 = 'FOOD_PREP_ON_PHONE2',
  FoodPrepOnPhone3 = 'FOOD_PREP_ON_PHONE3',
  OrderTransmissionOnEmail1 = 'ORDER_TRANSMISSION_ON_EMAIL1',
  OrderTransmissionOnEmail2 = 'ORDER_TRANSMISSION_ON_EMAIL2',
  OrderTransmissionOnEmail3 = 'ORDER_TRANSMISSION_ON_EMAIL3',
  OrderTransmissionOnFax = 'ORDER_TRANSMISSION_ON_FAX',
  OrderTransmissionOnPhone1 = 'ORDER_TRANSMISSION_ON_PHONE1',
  OrderTransmissionOnPhone2 = 'ORDER_TRANSMISSION_ON_PHONE2',
  OrderTransmissionOnPhone3 = 'ORDER_TRANSMISSION_ON_PHONE3',
}

/** The types of transmission methods that can be used to reach out to a caterer contact. */
export enum ContactOrderNotificationMethodEnum {
  Email = 'EMAIL',
  Fax = 'FAX',
  Phone = 'PHONE',
  Text = 'TEXT',
}

/** Input used to represent the number and label for a contact's phone number */
export type ContactPhoneNumberInput = {
  label: ContactPhoneNumberTypesEnum | `${ContactPhoneNumberTypesEnum}`;
  number: Scalars['String']['input'];
};

/** Descriptive labels for how a particular contact phone number is used. */
export enum ContactPhoneNumberTypesEnum {
  Catering = 'CATERING',
  Directentry = 'DIRECTENTRY',
  Home = 'HOME',
  Kitchen = 'KITCHEN',
  Mobile = 'MOBILE',
  None = 'NONE',
  Office = 'OFFICE',
  Phone = 'PHONE',
  Store = 'STORE',
  Work = 'WORK',
}

/** Inputs for creating a contact promo */
export type ContactPromoInput = {
  catererUuids: Array<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
  discountAmount: Scalars['Int']['input'];
  discountType: DiscountTypeEnum | `${DiscountTypeEnum}`;
  expiresOn: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderMinimum?: Scalars['Int']['input'];
  singleUsePerUser?: Scalars['Boolean']['input'];
  weekdayOnly: Scalars['Boolean']['input'];
};

/** Contact role assigned to a contact */
export type ContactRoleAssignmentInput = {
  field: CommunicationRoleEnum | `${CommunicationRoleEnum}`;
};

/** Arguments for sorting a contact */
export type ContactSort = {
  direction: SortDirection | `${SortDirection}`;
  field: ContactSortFields | `${ContactSortFields}`;
};

/** Allowed values for sorting a list of contact objects. */
export enum ContactSortFields {
  Id = 'ID',
  Name = 'NAME',
  PortalStatus = 'PORTAL_STATUS',
}

/** Types of content filters that may have triggered for a given message */
export enum ContentFilterTypes {
  /** Affects ezCater’s business, business model, or reputation */
  BusinessConcerns = 'BUSINESS_CONCERNS',
  /** Using offensive terms or phrases */
  Inappropriateness = 'INAPPROPRIATENESS',
  /** Content intended for/should be looked at by a CS agent */
  Misdirection = 'MISDIRECTION',
  /** Content indicating tension, frustration, or anger */
  Tone = 'TONE',
}

/** The input fields used to specify a geographical location. */
export type CoordinatesInput = {
  /** The coordinate's latitude value. */
  latitude: Scalars['Float']['input'];
  /** The coordinate's longitude value. */
  longitude: Scalars['Float']['input'];
};

/** Allowed types for a corp credit line share display type value */
export enum CorpCreditLineShareDisplay {
  CorpAccount = 'corp_account',
  Group = 'group',
  Person = 'person',
}

/** Allowed types for the entity with whom a corp credit line has been shared */
export enum CorpCreditLineSharedWith {
  CorpAccount = 'CorpAccount',
  CorpDeptCode = 'CorpDeptCode',
  CorpUser = 'CorpUser',
}

/** Allowed html input types (text, dropdown, etc) for a custom checkout field */
export enum CorpCustomCheckoutFieldEntry {
  DropdownSelector = 'dropdown_selector',
  TextEntry = 'text_entry',
}

/** Allowed fields for sorting invoices in a corp account */
export enum CorpInvoiceSortFields {
  Amount = 'amount',
  InvoiceNumber = 'invoiceNumber',
  InvoicedStatus = 'invoicedStatus',
  PaymentDueOn = 'paymentDueOn',
  PeriodEndAt = 'periodEndAt',
  PeriodStartAt = 'periodStartAt',
  SetName = 'setName',
}

/** Allowed values for the selected unit of time for a corp metric */
export enum CorpMetricTimeUnit {
  Months = 'months',
}

export type CorpOrderFiltersInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  corpDeptCodeId?: InputMaybe<Scalars['ID']['input']>;
  /** The final date, corresponding with an order's event_on, that a user wants to filter orders by */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  /** The payment type a user wants to filter orders by */
  paymentMethodType?: InputMaybe<OrderPaymentMethodTypeEnum | `${OrderPaymentMethodTypeEnum}`>;
  /** Option to include draft orders in the orders query */
  showDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  /** The first date, corresponding with an order's event_on, that a user wants to filter orders by */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<CorpOrderStatusFilter | `${CorpOrderStatusFilter}`>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Allowed fields for sorting orders/receipts in a corp account */
export enum CorpOrderSortFields {
  Address = 'address',
  Caterer = 'caterer',
  Department = 'department',
  EventDate = 'eventDate',
  Host = 'host',
  Order = 'order',
  OrderSubmitted = 'orderSubmitted',
  PaymentMethodType = 'paymentMethodType',
  Status = 'status',
  Total = 'total',
}

/** Displayable statuses for corp account orders */
export enum CorpOrderStatus {
  Canceled = 'canceled',
  Completed = 'completed',
  Draft = 'draft',
  PendingApproval = 'pending_approval',
  Scheduled = 'scheduled',
}

/** Filterable statuses for corp account orders */
export enum CorpOrderStatusFilter {
  All = 'all',
  Canceled = 'canceled',
  Completed = 'completed',
  Draft = 'draft',
  PendingApproval = 'pending_approval',
  Scheduled = 'scheduled',
}

/** Allowed fields for sorting reports in a corp account */
export enum CorpReportSortField {
  CreatedAt = 'createdAt',
  EndDate = 'endDate',
  Name = 'name',
  ReportType = 'reportType',
  RowCount = 'rowCount',
  StartDate = 'startDate',
}

/** Allowed corp report types */
export enum CorpReportType {
  Group = 'group',
  Order = 'order',
  OwnershipDiversity = 'ownership_diversity',
  Person = 'person',
}

/** Roles for user management under a corp account */
export enum CorpRole {
  Admin = 'admin',
  Orderer = 'orderer',
  Viewer = 'viewer',
}

/** Allowed statuses for a user in a corp account */
export enum CorpStatus {
  Customer = 'CUSTOMER',
  InviteSent = 'INVITE_SENT',
  None = 'NONE',
  Pending = 'PENDING',
  Registered = 'REGISTERED',
  Removed = 'REMOVED',
  Unverified = 'UNVERIFIED',
}

export type CorpUserFiltersInput = {
  corpDeptCode?: InputMaybe<Scalars['ID']['input']>;
  corpPolicy?: InputMaybe<Scalars['ID']['input']>;
  corpStatus?: InputMaybe<CorpStatus | `${CorpStatus}`>;
  /** Search for a user across a set of fields (name, email, phone) */
  freetext?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userUuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Allowed fields for sorting users in a corp account */
export enum CorpUserSortFields {
  CorpDeptCode = 'corpDeptCode',
  CorpPolicy = 'corpPolicy',
  CorpRoleId = 'corpRoleId',
  CorpStatusKey = 'corpStatusKey',
  InviteSentAt = 'inviteSentAt',
  LastActivityAt = 'lastActivityAt',
  Name = 'name',
  Orders = 'orders',
}

/** The different types of spending limits a corporate account can have for its users */
export enum CorporateAccountSpendingLimitTypes {
  AnnualBudget = 'ANNUAL_BUDGET',
  DailyBudget = 'DAILY_BUDGET',
  DeliveryFee = 'DELIVERY_FEE',
  DeliveryFeePerHead = 'DELIVERY_FEE_PER_HEAD',
  FoodCostPerHead = 'FOOD_COST_PER_HEAD',
  MinimumTipPercentage = 'MINIMUM_TIP_PERCENTAGE',
  MonthlyBudget = 'MONTHLY_BUDGET',
  QuarterlyBudget = 'QUARTERLY_BUDGET',
  Tip = 'TIP',
  TipPercentage = 'TIP_PERCENTAGE',
  TipPerHead = 'TIP_PER_HEAD',
  Total = 'TOTAL',
  TotalCostPerHead = 'TOTAL_COST_PER_HEAD',
  WeeklyBudget = 'WEEKLY_BUDGET',
}

/** Input type holding the customer data for the new order. */
export type CreateCatererSubmittedOrderCustomerInputType = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  identityId?: InputMaybe<Scalars['ID']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for creating a caterer submitted order */
export type CreateCatererSubmittedOrderInputType = {
  /** Customer info to start the order with. Used when you have customer info but no customer account yet */
  customer?: InputMaybe<CreateCatererSubmittedOrderCustomerInputType>;
  /** The customer account id to start the order with */
  customerAccountId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input object required to create a customer management promo */
export type CreateCustomerManagementPromoInput = {
  catererUuids: Array<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
  deliveryOnly: Scalars['Boolean']['input'];
  discountAmount: Scalars['Int']['input'];
  discountType:
    | CustomerManagementPromoDiscountTypeEnum
    | `${CustomerManagementPromoDiscountTypeEnum}`;
  expiresOn: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  orderMinimum?: InputMaybe<Scalars['Int']['input']>;
  singleUsePerUser: Scalars['Boolean']['input'];
  weekdayOnly: Scalars['Boolean']['input'];
};

/** Input arguments required to create a house account */
export type CreateHouseAccount = {
  address?: InputMaybe<AddressInput>;
  catererId?: InputMaybe<Scalars['ID']['input']>;
  catererIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyName: Scalars['String']['input'];
  contactFirstName: Scalars['String']['input'];
  contactLastName: Scalars['String']['input'];
  contactsToAssociate?: InputMaybe<Array<HouseAccountContactInput>>;
  email: Scalars['String']['input'];
  paymentTermsInDays: Scalars['Int']['input'];
  phone: Scalars['String']['input'];
  taxIdNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Input arguments required to create an invoice */
export type CreateInvoiceInput = {
  body: Scalars['String']['input'];
  houseAccountId: Scalars['ID']['input'];
  orderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  replyTo: Scalars['String']['input'];
  sendTo: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

/** Input arguments required to create a lead */
export type CreateLeadInput = {
  address?: InputMaybe<AddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  industry?: InputMaybe<IndustryTypeEnum | `${IndustryTypeEnum}`>;
  lastName: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  taxIdNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input arguments required to create a note for a given entity's activity timeline */
export type CreateNoteInput = {
  id: Scalars['ID']['input'];
  merged: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
};

/** Input type for creating an order item */
export type CreateOrderItemInputType = {
  /** Used to describe who the item is for when the eater is not in the system. Currently used by ClubSoda */
  labelFor?: InputMaybe<Scalars['String']['input']>;
  menuItemId: Scalars['ID']['input'];
  optionInputs?: InputMaybe<Array<OrderItemOptionInputType>>;
  orderId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Used by ClubSoda for accounting in case an item is removed from the menu */
  totalPrice?: InputMaybe<MoneyInput>;
  vegetarianQuantity?: InputMaybe<Scalars['Int']['input']>;
};

/** Allowed values for ImageCrop */
export enum CropName {
  DesktopHero = 'DESKTOP_HERO',
  DesktopMenuItem = 'DESKTOP_MENU_ITEM',
  DesktopMItem = 'DESKTOP_M_ITEM',
  MobileAbout = 'MOBILE_ABOUT',
  MobileHero = 'MOBILE_HERO',
  MobileSearch = 'MOBILE_SEARCH',
  RetinaMobileAbout = 'RETINA_MOBILE_ABOUT',
  RetinaMobileHero = 'RETINA_MOBILE_HERO',
  RetinaMobileMItem = 'RETINA_MOBILE_M_ITEM',
  RetinaMobileSearch = 'RETINA_MOBILE_SEARCH',
}

/** Allowed currency values for money */
export enum Currency {
  Usd = 'USD',
}

/** Allowed values for discounts on customer management promos */
export enum CustomerManagementPromoDiscountTypeEnum {
  DollarOff = 'DOLLAR_OFF',
  PercentOff = 'PERCENT_OFF',
}

/** Allowed values for the funding source on customer management promos */
export enum CustomerManagementPromoFundingSourceTypeEnum {
  CatererFunded = 'CATERER_FUNDED',
  EzcaterFunded = 'EZCATER_FUNDED',
}

/** The types of customer message actions that can appear on an order */
export enum CustomerMessageAction {
  CatererClosed = 'CATERER_CLOSED',
  CatererClosedForVacation = 'CATERER_CLOSED_FOR_VACATION',
  CatererDeliveryOnly = 'CATERER_DELIVERY_ONLY',
  CatererNotInStore = 'CATERER_NOT_IN_STORE',
  CatererNoBusinessOrders = 'CATERER_NO_BUSINESS_ORDERS',
  CatererNoResidentialOrders = 'CATERER_NO_RESIDENTIAL_ORDERS',
  CatererOutOfRange = 'CATERER_OUT_OF_RANGE',
  CatererTakeoutOnly = 'CATERER_TAKEOUT_ONLY',
  CreditCardMissingZipCode = 'CREDIT_CARD_MISSING_ZIP_CODE',
  EarlyDeliveryTime = 'EARLY_DELIVERY_TIME',
  GroupOrderInfo = 'GROUP_ORDER_INFO',
  ImpreciseOrderAddress = 'IMPRECISE_ORDER_ADDRESS',
  InvalidOrderAddress = 'INVALID_ORDER_ADDRESS',
  ItemsPastCutoff = 'ITEMS_PAST_CUTOFF',
  NoCaterer = 'NO_CATERER',
  NoOrderEventDateTime = 'NO_ORDER_EVENT_DATE_TIME',
  NoPaymentMethod = 'NO_PAYMENT_METHOD',
  NoShortNoticeChoice = 'NO_SHORT_NOTICE_CHOICE',
  OrderEventDatePassed = 'ORDER_EVENT_DATE_PASSED',
  OrderEventPastCutoff = 'ORDER_EVENT_PAST_CUTOFF',
  OrderIsModification = 'ORDER_IS_MODIFICATION',
  OrderItemsNotAvailable = 'ORDER_ITEMS_NOT_AVAILABLE',
  OrderNeedsReview = 'ORDER_NEEDS_REVIEW',
  OrderOverCorpSpendingLimit = 'ORDER_OVER_CORP_SPENDING_LIMIT',
  OrderOverGroupBudget = 'ORDER_OVER_GROUP_BUDGET',
  OrderSubmitted = 'ORDER_SUBMITTED',
  OrderUnderMinimum = 'ORDER_UNDER_MINIMUM',
  PromoCodeInfo = 'PROMO_CODE_INFO',
}

/** Action code for a customer message */
export enum CustomerMessageActionCode {
  ChangeCaterer = 'change_caterer',
  ChangeCatererOrEventDatetime = 'change_caterer_or_event_datetime',
  ChangeCatererOrOrderType = 'change_caterer_or_order_type',
  ChangeCatererOrSwitchToDelivery = 'change_caterer_or_switch_to_delivery',
  ChangeCatererOrSwitchToTakeout = 'change_caterer_or_switch_to_takeout',
  EditEventAddress = 'edit_event_address',
  EditEventDate = 'edit_event_date',
  EditEventDatetime = 'edit_event_datetime',
  EditEventTime = 'edit_event_time',
  EditInvalidEventDatetime = 'edit_invalid_event_datetime',
  OrderMessageGroupOrder = 'order_message_group_order',
  OrderMessageLinkToCart = 'order_message_link_to_cart',
  OrderMessageLinkToPayment = 'order_message_link_to_payment',
  OrderMessageLinkToPromo = 'order_message_link_to_promo',
  OrderMessageLinkToReview = 'order_message_link_to_review',
  OrderMessageLinkToSearch = 'order_message_link_to_search',
  OrderMessageModification = 'order_message_modification',
  OrderMessageShortNotice = 'order_message_short_notice',
  OrderMessageStatic = 'order_message_static',
  OrderSubmitted = 'order_submitted',
}

/** Area for a customer message */
export enum CustomerMessageArea {
  Cart = 'cart',
  CatererSearch = 'caterer_search',
  EventDetails = 'event_details',
  Menu = 'menu',
  MyAccountOrderShow = 'my_account_order_show',
  Payment = 'payment',
  ReviewOrder = 'review_order',
}

/** Error level for a customer message */
export enum CustomerMessageErrorLevel {
  High = 'high',
  Low = 'low',
  Medium = 'medium',
}

/** Type of a customer message */
export enum CustomerMessageTypeEnum {
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}

/** A list of values representing actions that a customer can take on an order. */
export enum CustomerOrderActions {
  Cancel = 'CANCEL',
  Continue = 'CONTINUE',
  Delete = 'DELETE',
  Edit = 'EDIT',
  Pdf = 'PDF',
  Reorder = 'REORDER',
  Review = 'REVIEW',
}

/** A selection of available filters to apply to the customers list */
export enum CustomersFilterTypeEnum {
  All = 'ALL',
  Sleepy = 'SLEEPY',
}

/** The types of fields that can be sorted by on a customer */
export enum CustomersSortFieldTypeEnum {
  Id = 'ID',
  Name = 'NAME',
  OrderCount = 'ORDER_COUNT',
}

/** Fields to update the daily order capacity for a store */
export type DailyOrderCapacity = {
  breakfastCount?: InputMaybe<Scalars['PositiveInt']['input']>;
  dayOfWeek: DaysOfWeek | `${DaysOfWeek}`;
  dinnerCount?: InputMaybe<Scalars['PositiveInt']['input']>;
  lunchCount?: InputMaybe<Scalars['PositiveInt']['input']>;
  orderCount?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/** Allowed values for days of the week */
export enum DaysOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

/** Types of Direct Connect events present in a history */
export enum DcEventTypes {
  /** a request was cancelled */
  Cancellation = 'CANCELLATION',
  /** a decision was made */
  Decision = 'DECISION',
  /** a message was sent */
  Message = 'MESSAGE',
  /** a request was placed */
  Request = 'REQUEST',
}

/** Input arguments required to delete customers */
export type DeleteCustomersInput = {
  ids: Array<Scalars['ID']['input']>;
};

/** Input arguments required to delete a house account */
export type DeleteHouseAccountInput = {
  id: Scalars['ID']['input'];
};

/** Input arguments required to delete leads */
export type DeleteLeadsInput = {
  ids: Array<Scalars['ID']['input']>;
};

/** Input arguments required to delete a note for a given entity's activity timeline */
export type DeleteNoteInput = {
  id: Scalars['ID']['input'];
  merged: Scalars['Boolean']['input'];
};

export enum DeliveryFeeFeeTypeEnum {
  Custom = 'CUSTOM',
  Fixed = 'FIXED',
  PercentOfFood = 'PERCENT_OF_FOOD',
  PerMile = 'PER_MILE',
}

/** Allowed values for sorting delivery performance order information. */
export enum DeliveryPerformanceOrderSortField {
  /** The name of the driver who delivered the order. */
  DriverName = 'DRIVER_NAME',
  /** The full event datetime of the order in the caterer's local time zone. */
  EventAt = 'EVENT_AT',
}

/** Arguments for sorting delivery performance order information. */
export type DeliveryPerformanceOrderSortInput = {
  /** The direction in which to sort delivery performance order information. */
  direction: SortDirection | `${SortDirection}`;
  /** Field by which to sort delivery performance order information. */
  field: DeliveryPerformanceOrderSortField | `${DeliveryPerformanceOrderSortField}`;
};

/** Allowed values for the review delivery professional feedback field */
export enum DeliveryProfessionalismFeedback {
  HighlyProfessional = 'HIGHLY_PROFESSIONAL',
  HighlyUnprofessional = 'HIGHLY_UNPROFESSIONAL',
  Neutral = 'NEUTRAL',
  Professional = 'PROFESSIONAL',
  Unprofessional = 'UNPROFESSIONAL',
}

/** Allowed values for delivery setup */
export enum DeliverySetup {
  /** The customer declined delivery setup */
  None = 'NONE',
  /** The customer was not prompted for a delivery setup */
  NoResponse = 'NO_RESPONSE',
  /** The customer requested delivery setup */
  Required = 'REQUIRED',
}

/** Allowed values for sorting a list of delivery objects */
export enum DeliverySortFields {
  DriverName = 'DRIVER_NAME',
  EventAt = 'EVENT_AT',
}

/** Current state - unassigned, assigned, in_progress, completed or expired - based on associated delivery events */
export enum DeliveryStatus {
  /** The delivery has been assigned to a driver. */
  Assigned = 'ASSIGNED',
  /** The delivery has been completed. */
  Completed = 'COMPLETED',
  /** The delivery was not completed at least two hours after the scheduled event. */
  Expired = 'EXPIRED',
  /** The delivery is currently in progress. */
  InProgress = 'IN_PROGRESS',
  /** The delivery has not been assigned to a driver. */
  Unassigned = 'UNASSIGNED',
}

/** Allowed values for the review delivery time feedback field */
export enum DeliveryTimeFeedback {
  Early = 'EARLY',
  Late = 'LATE',
  OnTime = 'ON_TIME',
}

/** The possible statuses for evaluating the delivery tracking data. */
export enum DeliveryTrackingEvaluationStatus {
  /** The delivery has tracking data but the data quality does not meet minimum requirements. */
  InvalidData = 'INVALID_DATA',
  /** The delivery did not receive all the required tracking data. */
  MissingRequiredData = 'MISSING_REQUIRED_DATA',
  /** The delivery is fully tracked. */
  Tracked = 'TRACKED',
  /** The delivery has no delivery tracking data. */
  Untracked = 'UNTRACKED',
}

/** The tracking statuses that a delivery can have. */
export enum DeliveryTrackingStatus {
  /** The delivery was fully tracked but the data does not meet our quality standards. */
  InvalidData = 'INVALID_DATA',
  /** The delivery is missing some of the required tracking data. */
  MissingRequiredData = 'MISSING_REQUIRED_DATA',
  /** The delivery was fully tracked and the data meets our quality standards. */
  Tracked = 'TRACKED',
  /** The delivery does not have any tracking data. */
  Untracked = 'UNTRACKED',
}

export enum DeliveryZoneZoneTypeEnum {
  Circle = 'CIRCLE',
  City = 'CITY',
  Distance = 'DISTANCE',
  Polygon = 'POLYGON',
  Rectangle = 'RECTANGLE',
  ZipCode = 'ZIP_CODE',
}

/** Required fields used to create demographic profiles for caterers. */
export type DemographicProfileUpsert = {
  catererIds: Array<Scalars['ID']['input']>;
  certification?: InputMaybe<Scalars['Boolean']['input']>;
  certificationDetails?: InputMaybe<Scalars['String']['input']>;
  consentForDataUse: Scalars['Boolean']['input'];
  disability?: InputMaybe<Scalars['String']['input']>;
  disabledVeteran?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Array<GenderDemographic | `${GenderDemographic}`>>;
  lgbtqiaPlusCommunity?: InputMaybe<Scalars['String']['input']>;
  ownershipCategory?: InputMaybe<OwnershipCategoryDemographic | `${OwnershipCategoryDemographic}`>;
  ownershipPercentage?: InputMaybe<
    OwnershipPercentageDemographic | `${OwnershipPercentageDemographic}`
  >;
  race?: InputMaybe<Array<RaceDemographic | `${RaceDemographic}`>>;
  smallBusiness?: InputMaybe<Scalars['String']['input']>;
  veteran?: InputMaybe<Scalars['String']['input']>;
};

/** Allowed values for dietary allergy */
export enum DietaryAllergy {
  Egg = 'EGG',
  FinFish = 'FIN_FISH',
  Milk = 'MILK',
  None = 'NONE',
  Peanut = 'PEANUT',
  Sesame = 'SESAME',
  Shellfish = 'SHELLFISH',
  Soy = 'SOY',
  TreeNut = 'TREE_NUT',
  Unknown = 'UNKNOWN',
  Wheat = 'WHEAT',
}

/** Allowed values for dietary options */
export enum DietaryOptionEnum {
  GlutenFree = 'GLUTEN_FREE',
  Halal = 'HALAL',
  Kosher = 'KOSHER',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN',
}

/** Whether or not a dietary poll can be answered. */
export enum DietaryPollStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
}

/** Allowed values for dietary preference */
export enum DietaryPreference {
  DairyFree = 'DAIRY_FREE',
  GlutenFree = 'GLUTEN_FREE',
  Halal = 'HALAL',
  Kosher = 'KOSHER',
  None = 'NONE',
  Paleo = 'PALEO',
  Pescatarian = 'PESCATARIAN',
  Unknown = 'UNKNOWN',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN',
}

/** Allowed values for discount types */
export enum DiscountTypeEnum {
  DollarOff = 'dollar_off',
  PercentOff = 'percent_off',
}

/** The delivery event creation source, whether directly or indirectly. */
export enum DmDeliveryEventSource {
  /** This is the default event source and any events that don't match other sources will be set to this. */
  DeliveryManagement = 'DELIVERY_MANAGEMENT',
  /** The event is directly from or a byproduct of a delivery partner. */
  DeliveryPartner = 'DELIVERY_PARTNER',
  /** The event is directly from or a byproduct of an ezDispatch process. */
  Ezdispatch = 'EZDISPATCH',
  /** The event was created from driver geolocation. */
  Geolocation = 'GEOLOCATION',
  /** The event was created from a 1st Party Delivery API integration. */
  PublicDeliveryApi = 'PUBLIC_DELIVERY_API',
}

/** The event type for any given event */
export enum DmDeliveryEventTypes {
  /** The ezDispatch request has been accepted - either programatically or by a third party delivery partner */
  Accepted = 'accepted',
  /** ezDispatch has cancelled the assignment to a third party delivery partner */
  AssignmentCancelled = 'assignment_cancelled',
  /** ezDispatch has assigned the delivery to a third party delivery partner */
  AssignmentCreated = 'assignment_created',
  /** The delivery has been cancelled completely */
  Cancelled = 'cancelled',
  /** A delivery record has been created in either delivery management or ezDispatch */
  Created = 'created',
  /** A driver has arrived at the dropoff location */
  DriverArrivedAtDropoff = 'driver_arrived_at_dropoff',
  /** A driver has arrived to pickup the food */
  DriverArrivedAtPickup = 'driver_arrived_at_pickup',
  /** A driver has been assigned - either by a catering partner or a third party delivery partner */
  DriverAssigned = 'driver_assigned',
  /** A driver has dropped of the food */
  DriverDroppedOff = 'driver_dropped_off',
  /** A driver is on the way to the customer */
  DriverEnRouteToDropoff = 'driver_en_route_to_dropoff',
  /** A driver is on the way to pickup the food */
  DriverEnRouteToPickup = 'driver_en_route_to_pickup',
  /** A driver has picked the food */
  DriverPickedUp = 'driver_picked_up',
  /** A driver has given feedback after completing a delivery */
  DriverProvidedFeedback = 'driver_provided_feedback',
  /**
   * A driver has reported that they are behind schedule
   * @deprecated This is being deprecated without any alternative. No delivery events have been created with this event type since 2022-02-09.
   */
  DriverReportedLateness = 'driver_reported_lateness',
  /** A gps location has been reported for a driver */
  DriverReportedLocation = 'driver_reported_location',
  /** A driver has been unassigned - either by a catering partner or third party delivery partner */
  DriverUnassigned = 'driver_unassigned',
  /** The delivery was not completed at least two hours after the scheduled event */
  Expired = 'expired',
  /** Some sort of issue has been reported with the delivery. */
  Issue = 'issue',
  /** Delivery related information has changed */
  Modified = 'modified',
  /** The delivery has been rejected by ezDispatch or an assignment has been rejected by a third party delivery partner */
  Rejected = 'rejected',
  /** ezDispatch request was deleted by the caterer. */
  RequestDeletedByCaterer = 'request_deleted_by_caterer',
  /** ezDispatch request was deleted by the customer. */
  RequestDeletedByCustomer = 'request_deleted_by_customer',
  /** ezDispatch request was deleted by the delivery partner. */
  RequestDeletedByDeliveryPartner = 'request_deleted_by_delivery_partner',
}

/** The priority level of an ezDispatch delivery. */
export enum DmDeliveryPriority {
  /** A delivery that needs higher priority. */
  High = 'HIGH',
  /** A normal delivery priority. This is the default. */
  Normal = 'NORMAL',
}

/** Current state - unassigned, assigned, in_progress, completed or expired - based on associated delivery events */
export enum DmDeliveryStatus {
  Assigned = 'assigned',
  Completed = 'completed',
  Expired = 'expired',
  InProgress = 'in_progress',
  Unassigned = 'unassigned',
}

/** The vendor hosting the image. */
export enum DmDriverImageVendor {
  Filestack = 'FILESTACK',
}

/** The input fields for creating or updating a caterer's delivery driver. */
export type DmDriverInput = {
  /** A list of globally unique identifiers for the Caterers that the driver delivers for. */
  ezcaterStoreIds: Array<Scalars['String']['input']>;
  /** The driver's first name. */
  firstName: Scalars['String']['input'];
  /** The driver's last name. */
  lastName: Scalars['String']['input'];
  /** The driver's vehicle make and model. */
  makeModel?: InputMaybe<Scalars['String']['input']>;
  /**
   * Internal notes about the driver for management purposes. This information is
   * not displayed to the driver or ezCater customers.
   */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The driver's mobile phone number. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Driver current SMS opt in status - no opt in decision, opted in, opted out */
export enum DmDriverOptInStatus {
  NoOptInDecision = 'NO_OPT_IN_DECISION',
  OptedIn = 'OPTED_IN',
  OptedOut = 'OPTED_OUT',
}

/** Autogenerated input type of DriverAccountMagicLinkCreate */
export type DriverAccountMagicLinkCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryId?: InputMaybe<Scalars['ID']['input']>;
  driverAssignmentId?: InputMaybe<Scalars['ID']['input']>;
  phone: Scalars['String']['input'];
  /** The origin of the driver self assignment. */
  source?: InputMaybe<DriverSelfAssignSource | `${DriverSelfAssignSource}`>;
};

/** Autogenerated input type of DriverAccountPushTokenCreate */
export type DriverAccountPushTokenCreateInput = {
  /** The mobile app version for the current device. For example: `1.2.3`. */
  appVersion: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Firebase token being added to the account. */
  firebaseToken: Scalars['String']['input'];
};

/** Autogenerated input type of DriverAccountPushTokenDestroy */
export type DriverAccountPushTokenDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Firebase token being removed from the account. */
  firebaseToken: Scalars['String']['input'];
};

/** Autogenerated input type of DriverAccountSelfCreate */
export type DriverAccountSelfCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryId?: InputMaybe<Scalars['ID']['input']>;
  phone: Scalars['String']['input'];
};

/** Autogenerated input type of DriverAccountSelfDelete */
export type DriverAccountSelfDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DriverAccountSessionCreate */
export type DriverAccountSessionCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated input type of DriverAccountSessionDestroy */
export type DriverAccountSessionDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DriverAccountSmsTermsAccept */
export type DriverAccountSmsTermsAcceptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Allowed values for driver app identifier. */
export enum DriverAppIdentifier {
  /** Android platform driver app. */
  AndroidDriver = 'ANDROID_DRIVER',
  /** iOS platform driver app. */
  IosDriver = 'IOS_DRIVER',
}

/** Autogenerated input type of DriverAssignmentFeedbackCreate */
export type DriverAssignmentFeedbackCreateInput = {
  /** ID of the driver assignment. */
  assignmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dropoffLocation?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DriverAssignmentImageCreate */
export type DriverAssignmentImageCreateInput = {
  /** ID of the Driver Assignment to attach the image to. */
  assignmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['File']['input'];
};

/** Autogenerated input type of DriverAssignmentMaskedCustomerPhoneNumberCreate */
export type DriverAssignmentMaskedCustomerPhoneNumberCreateInput = {
  /** ID of the driver assignment. */
  assignmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Allowed values for filtering assignments by their state. */
export enum DriverAssignmentState {
  /** Filter to only 'completed' assignments. */
  Completed = 'COMPLETED',
  /** Filter to only 'scheduled' (incomplete) assignments. */
  Scheduled = 'SCHEDULED',
}

/** Autogenerated input type of DriverAssignmentStatusUpdate */
export type DriverAssignmentStatusUpdateInput = {
  /** The globally-unique identifier of the driver assignment. */
  assignmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The new delivery lifecycle status. */
  status: DriverAssignmentStatusUpdateInputStatus | `${DriverAssignmentStatusUpdateInputStatus}`;
};

/** The status by the driver that describes the current state of the delivery lifecycle. */
export enum DriverAssignmentStatusUpdateInputStatus {
  /** The driver has dropped off the delivery. */
  DroppedOff = 'DROPPED_OFF',
  /** The driver has picked up the delivery. */
  PickedUp = 'PICKED_UP',
}

/** Autogenerated input type of DriverCreate */
export type DriverCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  driver: DmDriverInput;
};

/** Autogenerated input type of DriverDelete */
export type DriverDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the driver to be deleted */
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of DriverDeliverySelfAssign */
export type DriverDeliverySelfAssignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the delivery the driver is attempting to assign themselves to. */
  deliveryId: Scalars['ID']['input'];
  /** Driver provided first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Driver provided last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * When `true`, allows replacing an actively assigned driver with the requesting
   * driver. When `false` or omitted, a validation error will be returned if a
   * driver is already assigned.
   */
  replace?: InputMaybe<Scalars['Boolean']['input']>;
  /** Origin of the request. */
  source?: InputMaybe<DriverSelfAssignSource | `${DriverSelfAssignSource}`>;
};

/** Autogenerated input type of DriverEdit */
export type DriverEditInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  driver: DmDriverInput;
  /** ID of the driver to be edited */
  id: Scalars['ID']['input'];
};

/** Reasons why a delivery may not be self assignable. */
export enum DriverSelfAssignErrorCode {
  /** Delivery is already assigned to another driver. */
  Assigned = 'ASSIGNED',
  /** Delivery is now ezDispatch. */
  EzDispatch = 'EZ_DISPATCH',
  /** Delivery is now in a completed/expired/cancelled state. */
  Finalized = 'FINALIZED',
  /** Delivery is for Relish. */
  Relish = 'RELISH',
  /** Delivery is now takeout. */
  Takeout = 'TAKEOUT',
}

/** Sources from where the driver initiated the self assign. */
export enum DriverSelfAssignSource {
  /** Via the QR Code on the Order PDF. */
  Qrcode = 'QRCODE',
  /** Via an SMS with a link to sign up. */
  Sms = 'SMS',
}

/** Autogenerated input type of DriverTrackingEventCreate */
export type DriverTrackingEventCreateInput = {
  /** The globally-unique identifier of the driver assignment. */
  assignmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The location of where the event occurred by the driver. */
  coordinate: CoordinatesInput;
};

/** Input arguments required to edit a note for a given entity's activity timeline */
export type EditNoteInput = {
  id: Scalars['ID']['input'];
  merged: Scalars['Boolean']['input'];
  newText: Scalars['String']['input'];
};

export type EndCustomerManagementPromoInput = {
  /** The ID of the promo to end. */
  id: Scalars['ID']['input'];
};

export enum EntityTypeEnum {
  /** Brand */
  Brand = 'brand',
  /** Caterer */
  Caterer = 'caterer',
}

/** The event specific properties used when tracking events */
export type EventPropsInput = {
  appName: Scalars['String']['input'];
  browserHeight?: InputMaybe<Scalars['Int']['input']>;
  browserWidth?: InputMaybe<Scalars['Int']['input']>;
  category: Scalars['String']['input'];
  event: Scalars['String']['input'];
  experimentResult?: InputMaybe<Scalars['String']['input']>;
  experimentTest?: InputMaybe<Scalars['String']['input']>;
  miscJson?: InputMaybe<Scalars['JSON']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['String']['input']>;
  pixelRatio?: InputMaybe<Scalars['Float']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ExportDeliveryReportingData */
export type ExportDeliveryReportingDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Returns only deliveries with an event_at time in the given range. */
  eventAtRange: TimeRangeInput;
  /** Filters deliveries to the specified store or stores. */
  ezcaterStoreIds: Array<Scalars['String']['input']>;
};

/** The ezDispatch delivery lifecycle status. */
export enum EzDispatchDeliveryStatus {
  /** ezDispatch delivery is accepted. */
  Accepted = 'ACCEPTED',
  /** ezDispatch delivery is cancelled due to order cancellation. */
  Cancelled = 'CANCELLED',
  /** ezDispatch was requested, but the request was deleted. */
  Deleted = 'DELETED',
  /** ezDispatch delivery is pending acceptance. */
  Pending = 'PENDING',
  /** ezDispatch delivery is rejected. */
  Rejected = 'REJECTED',
}

/** Defines an attachment between an EzImage and another object */
export type EzImageAttachmentInput = {
  /** The uuid of the EzImage to attach */
  ezImageUuid: Scalars['UUID']['input'];
  /** The type of the object which the image should be attached */
  objectType: Scalars['String']['input'];
  /** The uuid of the object to which the image should be attached */
  objectUuid: Scalars['UUID']['input'];
  /** "Should we overwrite an already existing attachment? (default: false)" */
  replace?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Defines a crop box to be attached and EzImage */
export type EzImageCropBoxInput = {
  /** The uuid of the EzImage */
  ezImageUuid: Scalars['UUID']['input'];
  /** Draw the crop box to cover the full image */
  fullImage?: InputMaybe<Scalars['Boolean']['input']>;
  /** A distance along the Y-axis of the image to draw the box */
  h?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the crop box */
  name: Scalars['String']['input'];
  /** "Should we overwrite an already existing crop box? (default: false)" */
  replace?: InputMaybe<Scalars['Boolean']['input']>;
  /** A distance along the X-axis of the image to draw the box */
  w?: InputMaybe<Scalars['Int']['input']>;
  /** The X co-ordinate of a starting point on the image */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** The Y co-ordinate of a starting point on the image */
  y?: InputMaybe<Scalars['Int']['input']>;
};

/** Defines an image to be added */
export type EzImageInput = {
  /** The uuid of the owner */
  ownerId: Scalars['UUID']['input'];
  /** What type of entity owns this image. (Usually 'Brand') */
  ownerType: Scalars['String']['input'];
  /** A URL to download the image */
  remoteUrl: Scalars['String']['input'];
};

/** Input used to update the value of an ezManage permission. */
export type EzManagePermissionInput = {
  type: EzManagePermissionTypes | `${EzManagePermissionTypes}`;
  value: Scalars['Boolean']['input'];
};

/** Values corresponding to ezManage permissions types for a catering partner account. */
export enum EzManagePermissionTypes {
  BrandAdmin = 'BRAND_ADMIN',
  CanAcceptRejectOrders = 'CAN_ACCEPT_REJECT_ORDERS',
  CanAcceptRejectOrdersViaApi = 'CAN_ACCEPT_REJECT_ORDERS_VIA_API',
  CanCreateMenusViaApi = 'CAN_CREATE_MENUS_VIA_API',
  CanCreatePublicApiCredentials = 'CAN_CREATE_PUBLIC_API_CREDENTIALS',
  CanCreateStoreHoursViaApi = 'CAN_CREATE_STORE_HOURS_VIA_API',
  CanEditDirectEntryCustomMenuItems = 'CAN_EDIT_DIRECT_ENTRY_CUSTOM_MENU_ITEMS',
  CanEditDirectEntryDiscountsFees = 'CAN_EDIT_DIRECT_ENTRY_DISCOUNTS_FEES',
  CanEditLeadTimes = 'CAN_EDIT_LEAD_TIMES',
  CanEditOperatingHours = 'CAN_EDIT_OPERATING_HOURS',
  CanEditRankings = 'CAN_EDIT_RANKINGS',
  CanEditStoreDetails = 'CAN_EDIT_STORE_DETAILS',
  CanEditTemporaryClosures = 'CAN_EDIT_TEMPORARY_CLOSURES',
  CanEditUserSettings = 'CAN_EDIT_USER_SETTINGS',
  CanManageDemographicData = 'CAN_MANAGE_DEMOGRAPHIC_DATA',
  CanManagePromos = 'CAN_MANAGE_PROMOS',
  CanRequestSettingsUpdate = 'CAN_REQUEST_SETTINGS_UPDATE',
  CanViewDeliveryManagement = 'CAN_VIEW_DELIVERY_MANAGEMENT',
  CanViewDirectConnectMessages = 'CAN_VIEW_DIRECT_CONNECT_MESSAGES',
  CanViewDirectEntry = 'CAN_VIEW_DIRECT_ENTRY',
  CanViewOrders = 'CAN_VIEW_ORDERS',
  CanViewOrderPrices = 'CAN_VIEW_ORDER_PRICES',
  CanViewPayments = 'CAN_VIEW_PAYMENTS',
  CanViewPerformance = 'CAN_VIEW_PERFORMANCE',
  CanViewRankings = 'CAN_VIEW_RANKINGS',
  CanViewReports = 'CAN_VIEW_REPORTS',
  CanViewReviews = 'CAN_VIEW_REVIEWS',
  CanViewSettings = 'CAN_VIEW_SETTINGS',
  CanWriteDirectConnectMessages = 'CAN_WRITE_DIRECT_CONNECT_MESSAGES',
}

/** Allowed values for EzManageScopedActivationPermission error field */
export enum EzManageScopedActivationPermissionError {
  BrandAdmin = 'BRAND_ADMIN',
  MissingStores = 'MISSING_STORES',
  NotAuthorized = 'NOT_AUTHORIZED',
}

/** Required fields used to update ezRewards for a group of caterers */
export type EzRewardsUpdateLevel = {
  catererIds: Array<Scalars['ID']['input']>;
  level: Scalars['Int']['input'];
};

/** Allowed values to filter credits or deductions by type */
export enum FeeOrDiscountType {
  Adjustment = 'ADJUSTMENT',
  DeliveryFee = 'DELIVERY_FEE',
  Discount = 'DISCOUNT',
  MiscFee = 'MISC_FEE',
}

/** Input type for specifying file upload details */
export type FileUpload = {
  /** The MIME type of the file to be uploaded */
  contentType: Scalars['String']['input'];
  /** The name of the file to be uploaded */
  filename: Scalars['String']['input'];
};

export type FilterInput = {
  comparatorTarget: ComparatorTargetEnum | `${ComparatorTargetEnum}`;
  endDate: Scalars['Date']['input'];
  entityIds: Array<Scalars['ID']['input']>;
  entityType: EntityTypeEnum | `${EntityTypeEnum}`;
  ezcaterSourceName: Array<SourceNameEnum | `${SourceNameEnum}`>;
  granularity: GranularityEnum | `${GranularityEnum}`;
  startDate: Scalars['Date']['input'];
};

/** Arguments for filtering the consumer carts associated with a particular fulfillment detail */
export type FulfillmentDetailConsumerCartsFilterInput = {
  onlyNonEmptyCarts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The type of Order. */
export enum FulfillmentDetailStrategy {
  Delivery = 'DELIVERY',
  Takeout = 'TAKEOUT',
}

/** Categories of fulfillment issues */
export enum FulfillmentIssueCategory {
  DeliveryIssue = 'DELIVERY_ISSUE',
  FoodWasNotReadyForDelivery = 'FOOD_WAS_NOT_READY_FOR_DELIVERY',
  MissingFood = 'MISSING_FOOD',
  Other = 'OTHER',
  Uncategorized = 'UNCATEGORIZED',
}

/** The codes associated with fulfillment issues */
export enum FulfillmentIssueCode {
  ActOfGod = 'ACT_OF_GOD',
  CatererMiscommunication = 'CATERER_MISCOMMUNICATION',
  CustomerMiscommunication = 'CUSTOMER_MISCOMMUNICATION',
  CustomerUnprofessional = 'CUSTOMER_UNPROFESSIONAL',
  DeliveryInstructionsNotFollowed = 'DELIVERY_INSTRUCTIONS_NOT_FOLLOWED',
  DeliveryOutsourced = 'DELIVERY_OUTSOURCED',
  DeliveryPartiallyTracked = 'DELIVERY_PARTIALLY_TRACKED',
  DeliveryUntracked = 'DELIVERY_UNTRACKED',
  DietaryRequestsNotAccommodated = 'DIETARY_REQUESTS_NOT_ACCOMMODATED',
  DriverDidNotAdhereFoodSafetyRegulations = 'DRIVER_DID_NOT_ADHERE_FOOD_SAFETY_REGULATIONS',
  DriverMissingDeliveryEquipment = 'DRIVER_MISSING_DELIVERY_EQUIPMENT',
  DroppedOffToWrongLocation = 'DROPPED_OFF_TO_WRONG_LOCATION',
  Early = 'EARLY',
  EzcaterMiscommunication = 'EZCATER_MISCOMMUNICATION',
  EzcaterTechnologyIssue = 'EZCATER_TECHNOLOGY_ISSUE',
  EzdCatererFulfilledOrder = 'EZD_CATERER_FULFILLED_ORDER',
  EzdDriverLateToPickup = 'EZD_DRIVER_LATE_TO_PICKUP',
  EzdDriverLateToPickupFifteenToThirtyMinutesLate = 'EZD_DRIVER_LATE_TO_PICKUP_FIFTEEN_TO_THIRTY_MINUTES_LATE',
  EzdDriverLateToPickupFortyFiveToSixtyMinutesLate = 'EZD_DRIVER_LATE_TO_PICKUP_FORTY_FIVE_TO_SIXTY_MINUTES_LATE',
  EzdDriverLateToPickupSixtyPlusMinutesLate = 'EZD_DRIVER_LATE_TO_PICKUP_SIXTY_PLUS_MINUTES_LATE',
  EzdDriverLateToPickupThirtyToFortyFiveMinutesLate = 'EZD_DRIVER_LATE_TO_PICKUP_THIRTY_TO_FORTY_FIVE_MINUTES_LATE',
  EzdDriverLateToPickupZeroToFifteenMinutesLate = 'EZD_DRIVER_LATE_TO_PICKUP_ZERO_TO_FIFTEEN_MINUTES_LATE',
  EzdDriverNoShowForPickup = 'EZD_DRIVER_NO_SHOW_FOR_PICKUP',
  EzdFoodNotReadyForPickup = 'EZD_FOOD_NOT_READY_FOR_PICKUP',
  EzdFoodNotReadyForPickupFifteenToThirtyMinutesLate = 'EZD_FOOD_NOT_READY_FOR_PICKUP_FIFTEEN_TO_THIRTY_MINUTES_LATE',
  EzdFoodNotReadyForPickupFortyFiveToSixtyMinutesLate = 'EZD_FOOD_NOT_READY_FOR_PICKUP_FORTY_FIVE_TO_SIXTY_MINUTES_LATE',
  EzdFoodNotReadyForPickupSixtyPlusMinutesLate = 'EZD_FOOD_NOT_READY_FOR_PICKUP_SIXTY_PLUS_MINUTES_LATE',
  EzdFoodNotReadyForPickupThirtyToFortyFiveMinutesLate = 'EZD_FOOD_NOT_READY_FOR_PICKUP_THIRTY_TO_FORTY_FIVE_MINUTES_LATE',
  EzdFoodNotReadyForPickupZeroToFifteenMinutesLate = 'EZD_FOOD_NOT_READY_FOR_PICKUP_ZERO_TO_FIFTEEN_MINUTES_LATE',
  FifteenToThirtyMinLate = 'FIFTEEN_TO_THIRTY_MIN_LATE',
  FoodBadOrInedible = 'FOOD_BAD_OR_INEDIBLE',
  FoodNotIndividuallyPackaged = 'FOOD_NOT_INDIVIDUALLY_PACKAGED',
  IncorrectPreparation = 'INCORRECT_PREPARATION',
  LastMinuteModification = 'LAST_MINUTE_MODIFICATION',
  Late = 'LATE',
  LateDelivery = 'LATE_DELIVERY',
  LostDriver = 'LOST_DRIVER',
  MissingFood = 'MISSING_FOOD',
  MissingOrderItems = 'MISSING_ORDER_ITEMS',
  MissingUtensilsOrOtherEquipment = 'MISSING_UTENSILS_OR_OTHER_EQUIPMENT',
  MoreThanFifteenMinEarly = 'MORE_THAN_FIFTEEN_MIN_EARLY',
  MoreThanSixtyMinLate = 'MORE_THAN_SIXTY_MIN_LATE',
  NeverFulfilled = 'NEVER_FULFILLED',
  NotLabeledAsRequested = 'NOT_LABELED_AS_REQUESTED',
  NotPackagedAsRequested = 'NOT_PACKAGED_AS_REQUESTED',
  OrderDidNotArrive = 'ORDER_DID_NOT_ARRIVE',
  OrderNotSetup = 'ORDER_NOT_SETUP',
  PackagingBadOrDamaged = 'PACKAGING_BAD_OR_DAMAGED',
  ThirtyToSixtyMinLate = 'THIRTY_TO_SIXTY_MIN_LATE',
  TooEarly = 'TOO_EARLY',
  TooLate = 'TOO_LATE',
  TpdIssue = 'TPD_ISSUE',
  UnprofessionalDriver = 'UNPROFESSIONAL_DRIVER',
  UnresponsiveCaterer = 'UNRESPONSIVE_CATERER',
  WrongOrderDelivered = 'WRONG_ORDER_DELIVERED',
  ZeroToFifteenMinLate = 'ZERO_TO_FIFTEEN_MIN_LATE',
}

/** Input type for adding and updating fulfillment issues */
export type FulfillmentIssueInput = {
  idsToUpdate?: InputMaybe<Array<Scalars['ID']['input']>>;
  issueCodes: Array<Scalars['String']['input']>;
  missingOrderItems?: InputMaybe<Array<FulfillmentIssueMissingOrderItemInput>>;
  reporter?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Used for fulfillment issues where items are missing from an order. */
export type FulfillmentIssueMissingOrderItemInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  orderItemId: Scalars['ID']['input'];
  partiallyMissing: Scalars['Boolean']['input'];
  quantityMissing: Scalars['Int']['input'];
};

/** Entities that can report a fulfillment issue */
export enum FulfillmentIssueReporter {
  Caterer = 'CATERER',
  Customer = 'CUSTOMER',
  Ezcater = 'EZCATER',
  NlpCustomerReview = 'NLP_CUSTOMER_REVIEW',
  TpdPartner = 'TPD_PARTNER',
  Unknown = 'UNKNOWN',
}

/** Filters that control which fulfillment issues are returned for an order */
export enum FulfillmentIssuesFilter {
  CpVisible = 'CP_VISIBLE',
}

/** The gender options for a demographic profile */
export enum GenderDemographic {
  DeclineAnswer = 'DECLINE_ANSWER',
  DifferentDescription = 'DIFFERENT_DESCRIPTION',
  Man = 'MAN',
  NonBinary = 'NON_BINARY',
  Woman = 'WOMAN',
}

export enum GranularityEnum {
  /** Daily granularity */
  Day = 'day',
  /** Monthly granularity */
  Month = 'month',
  /** Weekly granularity */
  Week = 'week',
  /** Yearly granularity */
  Year = 'year',
}

/** Gratuity types that are available to concierge customers */
export enum Gratuity {
  FlatRatePerOrder = 'FLAT_RATE_PER_ORDER',
  OrderPercentage = 'ORDER_PERCENTAGE',
}

/** Type of campaign group distribution strategy */
export enum GroupTypeEnum {
  DistributeByDemand = 'DISTRIBUTE_BY_DEMAND',
  DistributeEvenly = 'DISTRIBUTE_EVENLY',
}

/** Fields required to submit a guided onboarding form as an admin */
export type GuidedOnboardingAdminFormSubmissionInput = {
  brandName: Scalars['String']['input'];
  brandStatus: GuidedOnboardingBrandStatusType | `${GuidedOnboardingBrandStatusType}`;
  brandType: GuidedOnboardingBrandType | `${GuidedOnboardingBrandType}`;
  catererGroupStatus?: InputMaybe<GuidedOnboardingRecordType | `${GuidedOnboardingRecordType}`>;
  catererNotes?: InputMaybe<Scalars['String']['input']>;
  catererStatus?: InputMaybe<GuidedOnboardingRecordType | `${GuidedOnboardingRecordType}`>;
  connectedToBusinessGroup?: InputMaybe<Scalars['Boolean']['input']>;
  enterpriseActivationDate?: InputMaybe<Scalars['Date']['input']>;
  existingBrandBlockBlocks?: InputMaybe<Array<GuidedOnboardingExistingBlockInput>>;
  existingBrandUrl?: InputMaybe<Scalars['String']['input']>;
  existingBusinessGroupBlocks?: InputMaybe<Array<GuidedOnboardingExistingBlockInput>>;
  existingBusinessGroupUrl?: InputMaybe<Scalars['String']['input']>;
  existingCatererGroupBlocks?: InputMaybe<Array<GuidedOnboardingExistingBlockInput>>;
  existingCatererGroupUrl?: InputMaybe<Scalars['String']['input']>;
  existingMarketplaceMenuUrl?: InputMaybe<Scalars['String']['input']>;
  hubspotDealId?: InputMaybe<Scalars['ID']['input']>;
  introCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  isHighPriorityLead: Scalars['Boolean']['input'];
  multiStoreUrl?: InputMaybe<Scalars['String']['input']>;
  newBusinessGroupName?: InputMaybe<Scalars['String']['input']>;
  numberOfStores?: InputMaybe<GuidedOnboardingNumberOfStores | `${GuidedOnboardingNumberOfStores}`>;
  salesFunnel: GuidedOnboardingSalesFunnel | `${GuidedOnboardingSalesFunnel}`;
  salesRepEmail?: InputMaybe<Scalars['String']['input']>;
  storeCardinality?: InputMaybe<
    GuidedOnboardingStoreCardinality | `${GuidedOnboardingStoreCardinality}`
  >;
};

/** A classification of the brand's status */
export enum GuidedOnboardingBrandStatusType {
  Existing = 'EXISTING',
  New = 'NEW',
}

/** A classification of the brand's type */
export enum GuidedOnboardingBrandType {
  Chain = 'CHAIN',
  Enterprise = 'ENTERPRISE',
  Indie = 'INDIE',
}

/** Allowed values for existing block categories */
export enum GuidedOnboardingExistingBlockCategory {
  BrandBlock = 'BRAND_BLOCK',
  BusinessGroup = 'BUSINESS_GROUP',
  CatererGroup = 'CATERER_GROUP',
}

/** Input type used to create an ExistingBlock record */
export type GuidedOnboardingExistingBlockInput = {
  blockType: GuidedOnboardingExistingBlockType | `${GuidedOnboardingExistingBlockType}`;
  category: GuidedOnboardingExistingBlockCategory | `${GuidedOnboardingExistingBlockCategory}`;
  url: Scalars['String']['input'];
};

/** Allowed values for existing block types */
export enum GuidedOnboardingExistingBlockType {
  BillingBlock = 'BILLING_BLOCK',
  CommissionBlock = 'COMMISSION_BLOCK',
  ContactsBlock = 'CONTACTS_BLOCK',
  DeliveryBlock = 'DELIVERY_BLOCK',
  MenuBlock = 'MENU_BLOCK',
  OpsBlock = 'OPS_BLOCK',
}

/** An indicator to know if the brand has one store or multiple locations */
export enum GuidedOnboardingNumberOfStores {
  MultipleLocations = 'MULTIPLE_LOCATIONS',
  OneLocation = 'ONE_LOCATION',
}

/** A classification of a record's type, either NEW or EXISTING */
export enum GuidedOnboardingRecordType {
  Existing = 'EXISTING',
  New = 'NEW',
}

/** Represents the source of CP acquisition added by sales team */
export enum GuidedOnboardingSalesFunnel {
  CommercialInbound = 'COMMERCIAL_INBOUND',
  CommercialOutbound = 'COMMERCIAL_OUTBOUND',
  DirectOnboarding = 'DIRECT_ONBOARDING',
  EmergingBrand = 'EMERGING_BRAND',
  Enterprise = 'ENTERPRISE',
  IndependentOutbound = 'INDEPENDENT_OUTBOUND',
  PullThrough = 'PULL_THROUGH',
}

/** A specific number of stores to capture detail beyond just one vs. many */
export enum GuidedOnboardingStoreCardinality {
  ElevenToTwenty = 'ELEVEN_TO_TWENTY',
  FiftyOneToNinetyNine = 'FIFTY_ONE_TO_NINETY_NINE',
  FortyOneToFifty = 'FORTY_ONE_TO_FIFTY',
  One = 'ONE',
  OneHundredOrMore = 'ONE_HUNDRED_OR_MORE',
  ThirtyOneToForty = 'THIRTY_ONE_TO_FORTY',
  TwentyOneToThirty = 'TWENTY_ONE_TO_THIRTY',
  TwoToTen = 'TWO_TO_TEN',
}

/** Represents open/close times for a given day of the week */
export type HoursOfOperationType = {
  closeTime: Scalars['TimeWithoutZone']['input'];
  day: Scalars['String']['input'];
  openTime: Scalars['TimeWithoutZone']['input'];
};

/** Input arguments required to authorize a lead or a customer to a house account */
export type HouseAccountContactInput = {
  contactId: Scalars['ID']['input'];
  contactType: HouseAccountContactTypeEnum | `${HouseAccountContactTypeEnum}`;
};

/** The types of contacts that can be associated with a house account */
export enum HouseAccountContactTypeEnum {
  Customer = 'CUSTOMER',
  Lead = 'LEAD',
}

/** The types of fields that can be sorted by on a house account */
export enum HouseAccountsSortFieldTypeEnum {
  AccountId = 'ACCOUNT_ID',
  BillingContact = 'BILLING_CONTACT',
  CompanyName = 'COMPANY_NAME',
  Id = 'ID',
  LastOrdered = 'LAST_ORDERED',
}

/** Allowed statuses on how menu items can be packaged */
export enum IndividualWrapStatus {
  /** The item is not wrapped */
  CannotBeIndividuallyWrapped = 'CANNOT_BE_INDIVIDUALLY_WRAPPED',
  /** The item is not wrapped but can be wrapped if requested */
  CanBeIndividuallyWrapped = 'CAN_BE_INDIVIDUALLY_WRAPPED',
  /** The item will always be wrapped */
  WillBeIndividuallyWrapped = 'WILL_BE_INDIVIDUALLY_WRAPPED',
}

/** Industries a contact is able to be associated with */
export enum IndustryTypeEnum {
  Accounting = 'accounting',
  Advertising = 'advertising',
  Construction = 'construction',
  Consulting = 'consulting',
  Education = 'education',
  Financial = 'financial',
  Healthcare = 'healthcare',
  Manufacturing = 'manufacturing',
  NonProfit = 'non_profit',
  Other = 'other',
  Pharma = 'pharma',
  RealEstate = 'real_estate',
  Retail = 'retail',
  Technology = 'technology',
  Utility = 'utility',
}

/** Allowed values for an Invitation's access scope. */
export enum InvitationAccessScope {
  AddItems = 'ADD_ITEMS',
  Checkout = 'CHECKOUT',
  ModifyAddress = 'MODIFY_ADDRESS',
  ModifyDatetime = 'MODIFY_DATETIME',
  ModifyOwnItems = 'MODIFY_OWN_ITEMS',
  Pay = 'PAY',
  View = 'VIEW',
}

/** Payment statuses for an invoice */
export enum InvoicePaymentStatus {
  Paid = 'paid',
  Unpaid = 'unpaid',
  Voided = 'voided',
}

/** The various statuses an invoice can have */
export enum InvoiceStatusType {
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Sent = 'SENT',
}

/** Attributes for each order item change */
export type ItemChangeInput = {
  changeType: OrderItemChangeTypes | `${OrderItemChangeTypes}`;
  originalItemJson: Scalars['String']['input'];
  proposedItemJson: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Defines the quantities an Item can be sold in. This includes both the minimum
 * quantity that can be sold and the increments the Item is available in. For
 * example, this could enable a sandwich Item to only be sold in groups of 5, with
 * a minimum of 10.
 */
export type ItemQuantityInput = {
  /**
   * Defines the specific allowed quantities that customers can select when buying
   * this Item.
   *
   * ---
   *
   * This field accepts a String made up of a comma-separated list of positive
   * integers less than 100. Any number of three or more digits will be truncated
   * to the first two.
   *
   * In addition, any integer in the comma-separated list can be preceded by the
   * following symbols as a shorthand for different behaviors:
   *
   * ">" is shorthand for every number greater than or equal to this number up to
   * 50, then every 5 up to, but not including, 100. For example, ">43" expands to:
   * "43, 44, 45, 46, 47, 48, 49, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95"
   *
   * "x" is shorthand for multiples of the number that follows it up to 50. For
   * example "x11" expands to "11, 22, 33, 44"
   *
   * ---
   *
   * This field defaults to ">1", meaning the numbers 1 to 50, then 50 to 95 in
   * increments of 5.
   */
  allowedValues?: InputMaybe<Scalars['String']['input']>;
  /**
   * What each quantity is. Common values include "box", "tray", "dozen",
   * "package", and "bowl".
   *
   * For Items that always only serve a single person, the default value for this
   * field is "person". For all other Items, the default value is null. Items that
   * only serve a single person are Items that either have a single ItemSize that
   * only serves one person, or Items that have multiple ItemSizes if the Item uses
   * volume pricing.
   */
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** An object to describe options for modifying an item selection */
export type ItemSelectionsInput = {
  maxCalories?: InputMaybe<Scalars['Int']['input']>;
  minCalories?: InputMaybe<Scalars['Int']['input']>;
  posId: Scalars['String']['input'];
  price: MoneyInput;
  serves?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
};

/** The types of fields that can be sorted by on a lead */
export enum LeadsSortFieldTypeEnum {
  Email = 'EMAIL',
  Id = 'ID',
  Industry = 'INDUSTRY',
  Name = 'NAME',
}

/** Allowed limit methods for a spending policy */
export enum LimitMethod {
  /** annual_budget */
  AnnualBudget = 'annual_budget',
  /** daily_budget */
  DailyBudget = 'daily_budget',
  /** delivery_fee */
  DeliveryFee = 'delivery_fee',
  /** delivery_fee_per_head */
  DeliveryFeePerHead = 'delivery_fee_per_head',
  /** food_cost_per_head */
  FoodCostPerHead = 'food_cost_per_head',
  /** monthly_budget */
  MonthlyBudget = 'monthly_budget',
  /** quarterly_budget */
  QuarterlyBudget = 'quarterly_budget',
  /** tip */
  Tip = 'tip',
  /** tip_per_head */
  TipPerHead = 'tip_per_head',
  /** tip_percentage_max */
  TipPercentageMax = 'tip_percentage_max',
  /** tip_percentage_min */
  TipPercentageMin = 'tip_percentage_min',
  /** total */
  Total = 'total',
  /** total_cost_per_head */
  TotalCostPerHead = 'total_cost_per_head',
  /** weekly_budget */
  WeeklyBudget = 'weekly_budget',
}

/** Allowed values for a line item's percent type */
export enum LineItemPercentTypeEnum {
  Food = 'FOOD',
}

/** Allowed values for line item type */
export enum LineItemTypeEnum {
  Adjustment = 'ADJUSTMENT',
  CatererFundedPromo = 'CATERER_FUNDED_PROMO',
  Commission = 'COMMISSION',
  CreditCardFee = 'CREDIT_CARD_FEE',
  CustomerPricingFee = 'CUSTOMER_PRICING_FEE',
  DeliveryFee = 'DELIVERY_FEE',
  Discount = 'DISCOUNT',
  ExternalIntegrationFee = 'EXTERNAL_INTEGRATION_FEE',
  EzRewardsCredit = 'EZ_REWARDS_CREDIT',
  MarketplaceFeesTax = 'MARKETPLACE_FEES_TAX',
  MiscFee = 'MISC_FEE',
  PointOfSaleIntegrationFee = 'POINT_OF_SALE_INTEGRATION_FEE',
  Promo = 'PROMO',
  RetailDeliveryFee = 'RETAIL_DELIVERY_FEE',
  RetailDeliveryFeeRemittance = 'RETAIL_DELIVERY_FEE_REMITTANCE',
  SalesTax = 'SALES_TAX',
  SalesTaxAdjustment = 'SALES_TAX_ADJUSTMENT',
  SalesTaxRemittance = 'SALES_TAX_REMITTANCE',
}

/** Allowed values for delivery tracking layout modifiers. */
export enum LiveDeliveryTrackingLayout {
  /**
   * Specifies that the delivery tracking page will be shown in an app webview.
   * This layout will prevent the web chat widget from being displayed.
   */
  AppWebview = 'APP_WEBVIEW',
  /**
   * Specifies that the delivery tracking page will only display the map component
   * (i.e. UI for the header, timeline, etc. are hidden). This is useful for
   * iframing the app.
   */
  MapOnly = 'MAP_ONLY',
}

/** Input arguments required to mark an invoice as paid */
export type MarkInvoicePaidInput = {
  invoiceId: Scalars['ID']['input'];
};

/** Input arguments required to mark an invoice as unpaid */
export type MarkInvoiceUnpaidInput = {
  invoiceId: Scalars['ID']['input'];
};

/** Arguments for sorting marketing activities */
export type MarketingActivitySortInputType = {
  direction: SortDirection | `${SortDirection}`;
  field: SupplierMarketingActivitySortField | `${SupplierMarketingActivitySortField}`;
};

/** Transaction type of a marketing activity */
export enum MarketingActivityTransactionTypeEnum {
  Charge = 'CHARGE',
  Payment = 'PAYMENT',
}

/** Allowed values for marketplace status field for Google Analytics 4 tracking */
export enum MarketplaceStatusEnum {
  Existing = 'existing',
  New = 'new',
}

/** Meal types that are available to concierge customers */
export enum Meal {
  Breakfast = 'BREAKFAST',
  Dessert = 'DESSERT',
  Dinner = 'DINNER',
  Lunch = 'LUNCH',
  Snacks = 'SNACKS',
  SpecialEvent = 'SPECIAL_EVENT',
}

/** Allowed values for the review delivery professional feedback field */
export enum MealTime {
  Breakfast = 'BREAKFAST',
  Day = 'DAY',
  Dinner = 'DINNER',
  Lunch = 'LUNCH',
}

/** Menu category filter options */
export enum MenuCategoryFilter {
  All = 'ALL',
  Displayable = 'DISPLAYABLE',
}

/** Input type for creating a new menu category */
export type MenuCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
};

/** Input type for creating a new menu choice. */
export type MenuChoiceInput = {
  /** Whether this choice is the default choice. */
  apiDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this choice is an award winner or not. */
  award?: InputMaybe<Scalars['Boolean']['input']>;
  catererNote?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether this choice is a dessert or not. */
  dessert?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this choice is a drink or not. */
  drinks?: InputMaybe<Scalars['Boolean']['input']>;
  externalId: Scalars['String']['input'];
  /** Whether this choice is gluten free or not. */
  glutenFree?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this choice is halal or not. */
  halal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this choice is healthy or not. */
  healthy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this choice comes with ice or not. */
  ice?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this choice can be an individually packaged relish side or not. */
  individuallyPackagedRelishSide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this choice is kosher or not. */
  kosher?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Whether this choice is popular or not. */
  popular?: InputMaybe<Scalars['Boolean']['input']>;
  /** Represents the additional cost of a choice on top of the base price of the item size chosen by a customer. */
  selections?: InputMaybe<Array<InputMaybe<MenuChoiceSelectionsInput>>>;
  /** Whether this choice is spicy or not. */
  spicy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identifies that the Caterer has suggested that the Choice is popular. */
  star?: InputMaybe<Scalars['Boolean']['input']>;
  subQuantities?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this choice comes with utensils or not. */
  utensils?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this choice is vegan or not. */
  vegan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this choice is vegetarian or not. */
  vegetarian?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input type for creating a new menu choice price. */
export type MenuChoiceSelectionsInput = {
  idForApi: Scalars['String']['input'];
  price?: InputMaybe<MoneyInput>;
};

/** An enumeration of the different types of disclaimers that apply to a menu */
export enum MenuDisclaimerKey {
  /**
   * ezCater menu prices may vary from, and be higher than, restaurant's menu
   * prices in-store or elsewhere and may reflect delivery-related fees.
   */
  DisclaimerPricing = 'DISCLAIMER_PRICING',
}

/** The type of entity that can be made available or unavailable */
export enum MenuEntityInput {
  /** Supports updating a MenuChoice */
  MenuChoice = 'MENU_CHOICE',
  /** Supports updating a MenuItem */
  MenuItem = 'MENU_ITEM',
}

/** MItem filter options */
export enum MenuItemFilter {
  All = 'ALL',
  Catering = 'CATERING',
  Live = 'LIVE',
}

/** Input type for creating a new menu item */
export type MenuItemInput = {
  award?: InputMaybe<Scalars['Boolean']['input']>;
  catererNote?: InputMaybe<Scalars['String']['input']>;
  channels: Array<ChannelNameEnum | `${ChannelNameEnum}`>;
  /** can supply lead time OR day before cutoff time */
  dayBeforeCutoffTime?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description2?: InputMaybe<Scalars['String']['input']>;
  dessert?: InputMaybe<Scalars['Boolean']['input']>;
  drinks?: InputMaybe<Scalars['Boolean']['input']>;
  externalId: Scalars['String']['input'];
  glutenFree?: InputMaybe<Scalars['Boolean']['input']>;
  halal?: InputMaybe<Scalars['Boolean']['input']>;
  healthy?: InputMaybe<Scalars['Boolean']['input']>;
  ice?: InputMaybe<Scalars['Boolean']['input']>;
  individualWrapStatus?: InputMaybe<IndividualWrapStatus | `${IndividualWrapStatus}`>;
  itemQuantityInput?: InputMaybe<ItemQuantityInput>;
  kosher?: InputMaybe<Scalars['Boolean']['input']>;
  /** can supply lead time OR day before cutoff time */
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  menuCategoryUuid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  popular?: InputMaybe<Scalars['Boolean']['input']>;
  salesTaxCode: SalesTaxCodeInput | `${SalesTaxCodeInput}`;
  selections: Array<InputMaybe<ItemSelectionsInput>>;
  sizeLabel?: InputMaybe<Scalars['String']['input']>;
  spicy?: InputMaybe<Scalars['Boolean']['input']>;
  star?: InputMaybe<Scalars['Boolean']['input']>;
  utensils?: InputMaybe<Scalars['Boolean']['input']>;
  vegan?: InputMaybe<Scalars['Boolean']['input']>;
  vegetarian?: InputMaybe<Scalars['Boolean']['input']>;
  vegetarianOption?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Allowed values for reporting period for a caterer account's menu item sales analysis. */
export enum MenuItemSalesAnalysisReportingPeriod {
  NinetyDays = 'NINETY_DAYS',
  SevenDays = 'SEVEN_DAYS',
  ThirtyDays = 'THIRTY_DAYS',
}

/** Allowed values for sorting a caterer account's list of menu item sales analyses. */
export enum MenuItemSalesAnalysisSort {
  ItemsPrice = 'ITEMS_PRICE',
  ItemsSold = 'ITEMS_SOLD',
  ItemsSoldPctChg = 'ITEMS_SOLD_PCT_CHG',
  ItemRevenue = 'ITEM_REVENUE',
  ItemRevenuePctChg = 'ITEM_REVENUE_PCT_CHG',
  MenuItemName = 'MENU_ITEM_NAME',
  OrdersWithItem = 'ORDERS_WITH_ITEM',
  OrdersWithItemPctChg = 'ORDERS_WITH_ITEM_PCT_CHG',
}

/** Arguments for sorting a list menu item sales analyses. */
export type MenuItemSalesAnalysisSortInput = {
  direction: SortDirection | `${SortDirection}`;
  field: MenuItemSalesAnalysisSort | `${MenuItemSalesAnalysisSort}`;
};

export enum MenuItemSizeStatus {
  Hidden = 'HIDDEN',
  Show = 'SHOW',
  Unavailable = 'UNAVAILABLE',
}

/** Input type for creating a new menu option. */
export type MenuOptionInput = {
  catererLabel?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  maxChoices?: InputMaybe<Scalars['Int']['input']>;
  menuChoices: Array<MenuChoiceInput>;
  minChoices: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
};

/** Values for the weight field of a MenuTagOverride. */
export enum MenuTagOverrideWeight {
  Invalid = 'INVALID',
  Valid = 'VALID',
}

/** Arguments for making a menu entity available */
export type MenuUnavailabilityClearInput = {
  catererId: Scalars['ID']['input'];
  entity: MenuEntityInput | `${MenuEntityInput}`;
  externalId: Scalars['ID']['input'];
};

/** Arguments for making a menu entity unavailable */
export type MenuUnavailabilitySetInput = {
  catererId: Scalars['ID']['input'];
  /**
   * The end date for the availability range. When not provided, signifies that the
   * unavailability period will continue indefinitely
   */
  endsAt?: InputMaybe<Scalars['Date']['input']>;
  entity: MenuEntityInput | `${MenuEntityInput}`;
  externalId: Scalars['ID']['input'];
  /** The start date for the availability range. When not provided, the unavailability period will begin today */
  startsAt?: InputMaybe<Scalars['Date']['input']>;
};

/** Destination for menu update */
export enum MenuUpdateDestination {
  Both = 'BOTH',
  Ezcater = 'EZCATER',
  Relish = 'RELISH',
}

/** States that a message may be in */
export enum MessageStatus {
  /** approved */
  Approved = 'APPROVED',
  /** blocked */
  Blocked = 'BLOCKED',
  /** flagged */
  Flagged = 'FLAGGED',
  /** pending */
  Pending = 'PENDING',
}

/** Allowed values for an order support reason */
export enum ModificationReasonEnum {
  AddItem = 'ADD_ITEM',
  ChangeStore = 'CHANGE_STORE',
  DeliveryTime = 'DELIVERY_TIME',
  ItemUnavailable = 'ITEM_UNAVAILABLE',
  ModifyItem = 'MODIFY_ITEM',
  Other = 'OTHER',
  PriceAdjustment = 'PRICE_ADJUSTMENT',
  RequestClarification = 'REQUEST_CLARIFICATION',
  RequestEzdispatch = 'REQUEST_EZDISPATCH',
  RequestEzdispatchWhenever = 'REQUEST_EZDISPATCH_WHENEVER',
}

export type MoneyInput = {
  currency?: InputMaybe<Currency | `${Currency}`>;
  subunits: Scalars['Int']['input'];
};

/** Notification types for Credit Line notices */
export enum Notice {
  ApproachingLimit = 'approaching_limit',
  AuthFailure = 'auth_failure',
  NearLimit = 'near_limit',
  OverLimit = 'over_limit',
}

/** Severity levels for Credit Line Notices */
export enum NotificationSeverity {
  Critical = 'critical',
  Info = 'info',
  Warning = 'warning',
}

/** Available onboarding form pages with UI page header titles */
export enum OnboardingFormPageEnum {
  /** Hours & delivery (1 of 2) */
  HoursAndDelivery_1 = 'HOURS_AND_DELIVERY_1',
  /** Hours & delivery (2 of 2) */
  HoursAndDelivery_2 = 'HOURS_AND_DELIVERY_2',
  /** Menu */
  Menu = 'MENU',
  /** Payment info (1 of 2) */
  PaymentInfo_1 = 'PAYMENT_INFO_1',
  /** Payment info (2 of 2) */
  PaymentInfo_2 = 'PAYMENT_INFO_2',
  /** Store & contact info (1 of 2) */
  StoreAndContactInfo_1 = 'STORE_AND_CONTACT_INFO_1',
  /** Store & contact info (2 of 2) */
  StoreAndContactInfo_2 = 'STORE_AND_CONTACT_INFO_2',
}

/** Allowed values for source of operating hours */
export enum OperatingHoursSource {
  Api = 'API',
  Human = 'HUMAN',
}

/** Allowed values for operating schedule object arguments. */
export type OperatingScheduleInput = {
  operatingHours: Array<HoursOfOperationType>;
  scheduleType: Scalars['String']['input'];
};

/** Allowed values for sorting a caterer account's list of stores */
export enum OperationalMetricsStoreSortField {
  AdjustedAvgStarRating = 'ADJUSTED_AVG_STAR_RATING',
  AutoInterventionStatus = 'AUTO_INTERVENTION_STATUS',
  CancelPercentRolling_90Days = 'CANCEL_PERCENT_ROLLING_90_DAYS',
  FoodReadyPercentRolling_90Days = 'FOOD_READY_PERCENT_ROLLING_90_DAYS',
  IsReliabilityRockstar = 'IS_RELIABILITY_ROCKSTAR',
  OntimePercentRolling_90Days = 'ONTIME_PERCENT_ROLLING_90_DAYS',
  OrderAccuratePercentRolling_90Days = 'ORDER_ACCURATE_PERCENT_ROLLING_90_DAYS',
  RejectPercentRolling_90Days = 'REJECT_PERCENT_ROLLING_90_DAYS',
  ResponsivenessPercentRolling_90Days = 'RESPONSIVENESS_PERCENT_ROLLING_90_DAYS',
  TrackedDeliveryPercentRolling_90Days = 'TRACKED_DELIVERY_PERCENT_ROLLING_90_DAYS',
}

/** Arguments for sorting a list of stores for a caterer account on the operational metrics page. */
export type OperationalMetricsStoreSortInput = {
  direction: SortDirection | `${SortDirection}`;
  field: OperationalMetricsStoreSortField | `${OperationalMetricsStoreSortField}`;
};

/** Allowed values for the metric name field in an Operational Performance Metric */
export enum OperationalPerformanceMetricName {
  AdjustedAvgStarRating = 'ADJUSTED_AVG_STAR_RATING',
  CancelPercentRolling_90Days = 'CANCEL_PERCENT_ROLLING_90_DAYS',
  FoodReadyPercentRolling_90Days = 'FOOD_READY_PERCENT_ROLLING_90_DAYS',
  OntimePercentRolling_90Days = 'ONTIME_PERCENT_ROLLING_90_DAYS',
  OrderAccuratePercentRolling_90Days = 'ORDER_ACCURATE_PERCENT_ROLLING_90_DAYS',
  RejectPercentRolling_90Days = 'REJECT_PERCENT_ROLLING_90_DAYS',
  ResponsivenessPercentRolling_90Days = 'RESPONSIVENESS_PERCENT_ROLLING_90_DAYS',
  TrackedDeliveryPercentRolling_90Days = 'TRACKED_DELIVERY_PERCENT_ROLLING_90_DAYS',
}

/** Allowed order action values */
export enum OrderActionsEnum {
  AcceptAction = 'accept_action',
  AcknowledgeAction = 'acknowledge_action',
  CancelAction = 'cancel_action',
  CatererSubmittedRefundAction = 'caterer_submitted_refund_action',
  ChangeRejectAction = 'change_reject_action',
  CompleteExternalPaymentAction = 'complete_external_payment_action',
  ConfirmCancellationAction = 'confirm_cancellation_action',
  ConfirmModificationAction = 'confirm_modification_action',
  DriverAssignAction = 'driver_assign_action',
  EditAction = 'edit_action',
  FoodPrepAction = 'food_prep_action',
  RejectAction = 'reject_action',
  RequestEzdispatchAction = 'request_ezdispatch_action',
  RequestModificationAction = 'request_modification_action',
  UndoCompleteExternalPaymentAction = 'undo_complete_external_payment_action',
}

/** Attributes for order detail information */
export type OrderInfoInput = {
  brandName: Scalars['String']['input'];
  eventAt: Scalars['ISO8601DateTime']['input'];
  /** may be a valid TZ name or an ISO offset */
  eventTimeZone?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isPickup?: InputMaybe<Scalars['Boolean']['input']>;
  orderNumber: Scalars['String']['input'];
  userUuid: Scalars['ID']['input'];
};

/** Ways in which an order item may be changed */
export enum OrderItemChangeTypes {
  /** addition */
  Addition = 'ADDITION',
  /** deletion */
  Deletion = 'DELETION',
  /** modification */
  Modification = 'MODIFICATION',
  /** substitution */
  Substitution = 'SUBSTITUTION',
}

/** Input type for an order item choice */
export type OrderItemChoiceInputType = {
  menuChoiceId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** Input type for an order item option */
export type OrderItemOptionInputType = {
  choiceInputs?: InputMaybe<Array<InputMaybe<OrderItemChoiceInputType>>>;
  menuOptionId: Scalars['ID']['input'];
};

export enum OrderOrdinalFilterEnum {
  NotCancelled = 'NOT_CANCELLED',
  Submitted = 'SUBMITTED',
  WithoutCatererSubmitted = 'WITHOUT_CATERER_SUBMITTED',
}

export enum OrderOrdinalScopeEnum {
  Consumer = 'CONSUMER',
}

export enum OrderOrdinalSortedByEnum {
  SubmittedAt = 'SUBMITTED_AT',
}

/** Allowed values for order payment method type */
export enum OrderPaymentMethodTypeEnum {
  CorpCreditLine = 'corp_credit_line',
  CreditCard = 'credit_card',
  Refund = 'refund',
}

/** Arguments for creating OrderReadyForPickupMetadatum */
export type OrderReadyForPickupMetadatumInput = {
  /** Time when food was marked ready */
  foodMarkedReadyForPickupAt: Scalars['ISO8601DateTime']['input'];
  /** ID of the contact who marked the food ready */
  foodMarkedReadyForPickupByContactId?: InputMaybe<Scalars['ID']['input']>;
  /** Number of packages in the order */
  numberOfPackages: Scalars['Int']['input'];
  /** ID of the order */
  orderId: Scalars['ID']['input'];
  /** ID of the contact who printed the PDF */
  pdfPrintedByContactId?: InputMaybe<Scalars['ID']['input']>;
  /** Time when the photo was deleted */
  photoDeletedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /**
   * ID of the contact who deleted the photo
   * @deprecated photo deletion by admin only
   */
  photoDeletedByContactId?: InputMaybe<Scalars['ID']['input']>;
  /** Key of the photo */
  photoKey?: InputMaybe<Scalars['String']['input']>;
};

/** Allowed values for short-notice action */
export enum OrderShortNoticeActions {
  Cancel = 'CANCEL',
  None = 'NONE',
  Substitute = 'SUBSTITUTE',
  Takeout = 'TAKEOUT',
}

/** Arguments for sorting orders */
export type OrderSortInputType = {
  direction: SortDirection | `${SortDirection}`;
  field: CatererOrderSortField | `${CatererOrderSortField}`;
};

/** Allowed values for order sources. An order source represents what user flow the order originated from */
export enum OrderSource {
  ClubSoda = 'CLUB_SODA',
  DirectEntry = 'DIRECT_ENTRY',
  EzOrdering = 'EZ_ORDERING',
  Marketplace = 'MARKETPLACE',
}

/** Allowed values for order state filtering */
export enum OrderStateFilterEnum {
  All = 'ALL',
  Cancelled = 'CANCELLED',
  CancelledNotRejected = 'CANCELLED_NOT_REJECTED',
  Draft = 'DRAFT',
  FulfilledAndUnpaid = 'FULFILLED_AND_UNPAID',
  Past = 'PAST',
  PendingApproval = 'PENDING_APPROVAL',
  PendingReview = 'PENDING_REVIEW',
  Receipt = 'RECEIPT',
  Rejected = 'REJECTED',
  Reviewable = 'REVIEWABLE',
  Submitted = 'SUBMITTED',
  SubmittedNotCancelled = 'SUBMITTED_NOT_CANCELLED',
  Unpaid = 'UNPAID',
  Upcoming = 'UPCOMING',
  UpcomingAndDrafts = 'UPCOMING_AND_DRAFTS',
  UpcomingNotPendingApproval = 'UPCOMING_NOT_PENDING_APPROVAL',
}

/** Allowed values for order task state filtering */
export enum OrderTaskFilter {
  Actionable = 'ACTIONABLE',
  All = 'ALL',
  Scheduled = 'SCHEDULED',
}

/** Class names for order task instruction polymorphic association */
export enum OrderTaskInstructionsObject {
  Brand = 'BRAND',
  BusinessGroup = 'BUSINESS_GROUP',
  Caterer = 'CATERER',
  CatererGroup = 'CATERER_GROUP',
  ContactsBlock = 'CONTACTS_BLOCK',
  User = 'USER',
}

/** Issue types for an order task */
export enum OrderTaskIssue {
  Blocked = 'BLOCKED',
  Paused = 'PAUSED',
  Processing = 'PROCESSING',
  Snoozing = 'SNOOZING',
  TooSoon = 'TOO_SOON',
}

/** Allowed values for order type */
export enum OrderTypeEnum {
  Delivery = 'DELIVERY',
  Takeout = 'TAKEOUT',
  ThirdPartyDelivery = 'THIRD_PARTY_DELIVERY',
}

/** Allowed values for an order type perspective */
export enum OrderTypePerspective {
  Caterer = 'CATERER',
  Customer = 'CUSTOMER',
  Ezcater = 'EZCATER',
}

/** The overall tracking statuses that an order can have. */
export enum OverallTrackingStatus {
  /** The delivery does not have complete tracking data that meets our quality standards. */
  PartiallyTracked = 'PARTIALLY_TRACKED',
  /** The delivery was fully tracked and the data meets our quality standards. */
  Tracked = 'TRACKED',
  /** The delivery does not have any tracking data. */
  Untracked = 'UNTRACKED',
}

/** The ownership category options for a demographic profile */
export enum OwnershipCategoryDemographic {
  CorporateOffice = 'CORPORATE_OFFICE',
  FranchiseGroup = 'FRANCHISE_GROUP',
  IndependentEntity = 'INDEPENDENT_ENTITY',
  IndependentFranchisee = 'INDEPENDENT_FRANCHISEE',
}

/** The ownership percentage options for a demographic profile */
export enum OwnershipPercentageDemographic {
  BuisnessOwnerUnknown = 'BUISNESS_OWNER_UNKNOWN',
  NoMajorityOwner = 'NO_MAJORITY_OWNER',
  OnePersonOwnsAtLeast_50Percent = 'ONE_PERSON_OWNS_AT_LEAST_50_PERCENT',
  TwoPeopleOwn_50Percent = 'TWO_PEOPLE_OWN_50_PERCENT',
}

/** Type of payees on the billing blocks */
export enum PayeeTypeEnum {
  Business = 'BUSINESS',
  Individual = 'INDIVIDUAL',
}

/** Type of payment method on Billing Blocks */
export enum PaymentMethodEnum {
  Ach = 'ACH',
  Check = 'CHECK',
}

/** Allowed values for payment method type */
export enum PaymentMethodTypeEnum {
  CreditCard = 'CreditCard',
  CreditLine = 'CreditLine',
}

/** Representation of the type of status in terms of how it should be displayed */
export enum PaymentStatusDisplay {
  Error = 'ERROR',
  Warning = 'WARNING',
}

export enum PayoneerStatus {
  Approved = 'approved',
  Declined = 'declined',
  InProgress = 'in_progress',
  NotRegistered = 'not_registered',
}

/** Allowed values for the performance status field */
export enum PerformanceStatus {
  Green = 'GREEN',
  Red = 'RED',
  Yellow = 'YELLOW',
}

/** ezCater defined holidays for caterers to opt into being closed every year */
export enum PredefinedHolidayType {
  ChristmasDay = 'CHRISTMAS_DAY',
  ChristmasEve = 'CHRISTMAS_EVE',
  CincoDeMayo = 'CINCO_DE_MAYO',
  EarthDay = 'EARTH_DAY',
  EasterSunday = 'EASTER_SUNDAY',
  FatherSDay = 'FATHER_S_DAY',
  Halloween = 'HALLOWEEN',
  IndependenceDay = 'INDEPENDENCE_DAY',
  IndigenousPeopleSDay = 'INDIGENOUS_PEOPLE_S_DAY',
  Juneteenth = 'JUNETEENTH',
  LaborDay = 'LABOR_DAY',
  MardiGras = 'MARDI_GRAS',
  MartinLutherKingJrDay = 'MARTIN_LUTHER_KING_JR_DAY',
  MemorialDay = 'MEMORIAL_DAY',
  MotherSDay = 'MOTHER_S_DAY',
  NewYearSDay = 'NEW_YEAR_S_DAY',
  NewYearSEve = 'NEW_YEAR_S_EVE',
  StPatrickSDay = 'ST_PATRICK_S_DAY',
  Thanksgiving = 'THANKSGIVING',
  VeteransDay = 'VETERANS_DAY',
}

/** Required fields used to update PPP */
export type PreferredPartnerProgramUpdateRate = {
  catererIds: Array<Scalars['ID']['input']>;
  rate: Scalars['Int']['input'];
};

/** Different methods used when calculating a cart's price per head value. */
export enum PricePerHeadCalculationMethod {
  CustomerTotal = 'CUSTOMER_TOTAL',
  Food = 'FOOD',
}

/** The menu system */
export enum ProductCatalog {
  /** The classic menu system: m_item, m_option, m_choice */
  Classic = 'CLASSIC',
  /** The menus core system */
  Menuevo = 'MENUEVO',
}

/** The available funding sources for promos */
export enum PromoFundingTypeEnum {
  /** This promotion is funded by the caterer */
  CatererFunded = 'caterer_funded',
  /** This promotion is funded by ezCater */
  EzcaterFunded = 'ezcater_funded',
}

/** Allowed values for the order sort field */
export enum PromoOrderSortField {
  SubmittedAt = 'SUBMITTED_AT',
}

/** Arguments for sorting orders for a promo */
export type PromoOrderSortType = {
  direction: SortDirection | `${SortDirection}`;
  field: PromoOrderSortField | `${PromoOrderSortField}`;
};

/** The status of a promotion */
export enum PromoStatusEnum {
  /** The promotion is active */
  Active = 'ACTIVE',
  /** The promotion has expired */
  Expired = 'EXPIRED',
}

/** All the available statuses in which a promo can be */
export enum PromoStatusTypeEnum {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
}

/** The channels that this promo is applicable to. */
export enum PromoTargetChannelEnum {
  All = 'ALL',
  Marketplace = 'MARKETPLACE',
  PrivateStore = 'PRIVATE_STORE',
}

/** Publicly accessible taxonomies */
export enum PublicTaxonomies {
  /** Promotions taxonomy */
  PromotionsTaxonomy = 'PROMOTIONS_TAXONOMY',
  /** Service capabilities taxonomy */
  ServiceCapabilitiesTaxonomy = 'SERVICE_CAPABILITIES_TAXONOMY',
}

/** The race options for a demographic profile */
export enum RaceDemographic {
  AsianNativeHawaiianPacificIslander = 'ASIAN_NATIVE_HAWAIIAN_PACIFIC_ISLANDER',
  BlackOrAfricanDescent = 'BLACK_OR_AFRICAN_DESCENT',
  DeclineAnswer = 'DECLINE_ANSWER',
  DifferentDescription = 'DIFFERENT_DESCRIPTION',
  HispanicLatinxSpanish = 'HISPANIC_LATINX_SPANISH',
  IndigenousAmericanIndianAlaskanNative = 'INDIGENOUS_AMERICAN_INDIAN_ALASKAN_NATIVE',
  MiddleEasternNorthAfrican = 'MIDDLE_EASTERN_NORTH_AFRICAN',
  WhiteOrEuropean = 'WHITE_OR_EUROPEAN',
}

/** Autogenerated input type of RecordDecision */
export type RecordDecisionInput = {
  adminUserUuid?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  decisionUuid: Scalars['ID']['input'];
  /** @deprecated use comment instead */
  responderComment?: InputMaybe<Scalars['String']['input']>;
  response: Scalars['Boolean']['input'];
};

/** Autogenerated input type of RecordMessage */
export type RecordMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  /** @deprecated use sentByType instead */
  initiatorType?: InputMaybe<ActorTypes | `${ActorTypes}`>;
  /** @deprecated use sentById instead */
  initiatorUuid?: InputMaybe<Scalars['ID']['input']>;
  orderInfo: OrderInfoInput;
  sentById?: InputMaybe<Scalars['ID']['input']>;
  sentByType?: InputMaybe<ActorTypes | `${ActorTypes}`>;
};

/** Days that are available for recurring concierge orders */
export enum RecurringDay {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

/** Allowed values for referral reminder status */
export enum ReferralReminderStatusTypeEnum {
  Enabled = 'ENABLED',
  PermanentlyDisabled = 'PERMANENTLY_DISABLED',
  TemporarilyDisabled = 'TEMPORARILY_DISABLED',
}

/** Allowed values for referral reminder type */
export enum ReferralReminderTypeEnum {
  Nudge = 'NUDGE',
  Resend = 'RESEND',
}

/** Allowed values for the referral status field */
export enum ReferralStatusEnum {
  Deleted = 'Deleted',
  Invited = 'Invited',
  Joined = 'Joined',
  Ordered = 'Ordered',
}

/** Allowed values for referral status filter */
export enum ReferralStatusFilterEnum {
  Invited = 'INVITED',
  Joined = 'JOINED',
}

/** Input type for creating a new Registered Business */
export type RegisteredBusinessCreateInput = {
  address?: InputMaybe<AddressFields>;
  addressId?: InputMaybe<Scalars['ID']['input']>;
  federalTaxId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input type for updating a Registered Business */
export type RegisteredBusinessUpdateInput = {
  address?: InputMaybe<AddressFields>;
  addressId?: InputMaybe<Scalars['ID']['input']>;
  federalTaxId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Category for CP rejection reasons */
export enum RejectionReasonCategory {
  Other = 'OTHER',
  StoreUnavailable = 'STORE_UNAVAILABLE',
  UnableToDeliver = 'UNABLE_TO_DELIVER',
  UnableToPrepareFood = 'UNABLE_TO_PREPARE_FOOD',
}

/** Allowed values for an order rejection reason */
export enum RejectionReasonEnum {
  AtDailyCapacity = 'AT_DAILY_CAPACITY',
  AtHourlyCapacity = 'AT_HOURLY_CAPACITY',
  CommissionOrFeesTooHigh = 'COMMISSION_OR_FEES_TOO_HIGH',
  DistanceTooFar = 'DISTANCE_TOO_FAR',
  DoesNotOfferTakeOutOrDelivery = 'DOES_NOT_OFFER_TAKE_OUT_OR_DELIVERY',
  DoesNotRememberSigningUpForEzcater = 'DOES_NOT_REMEMBER_SIGNING_UP_FOR_EZCATER',
  EmergencyClosure = 'EMERGENCY_CLOSURE',
  HolidayClosure = 'HOLIDAY_CLOSURE',
  LackOfInventory = 'LACK_OF_INVENTORY',
  LeadTimeTooShortToDeliver = 'LEAD_TIME_TOO_SHORT_TO_DELIVER',
  LeadTimeTooShortToPrepare = 'LEAD_TIME_TOO_SHORT_TO_PREPARE',
  MenuIncorrect = 'MENU_INCORRECT',
  MissingCustomerContactInformation = 'MISSING_CUSTOMER_CONTACT_INFORMATION',
  NoDriversAvailable = 'NO_DRIVERS_AVAILABLE',
  NoTip = 'NO_TIP',
  OutOfBusiness = 'OUT_OF_BUSINESS',
  OwnershipChanged = 'OWNERSHIP_CHANGED',
  /** @deprecated use out_of_business instead */
  PermanentlyClosed = 'PERMANENTLY_CLOSED',
  ReasonNotListed = 'REASON_NOT_LISTED',
  StaffShortage = 'STAFF_SHORTAGE',
  TemporarilyClosed = 'TEMPORARILY_CLOSED',
  Weather = 'WEATHER',
  WrongHours = 'WRONG_HOURS',
}

/** Input arguments required to remove a customer from a house account */
export type RemoveCustomerFromHouseAccountInput = {
  customerId: Scalars['ID']['input'];
  houseAccountId: Scalars['ID']['input'];
};

/** Input arguments required to remove a lead from a house account */
export type RemoveLeadFromHouseAccountInput = {
  houseAccountId: Scalars['ID']['input'];
  leadId: Scalars['ID']['input'];
};

/** The statusses in which a report can be */
export enum ReportStatusEnum {
  Complete = 'COMPLETE',
  Processing = 'PROCESSING',
}

/** The types of available reports */
export enum ReportTypeEnum {
  Customers = 'CUSTOMERS',
}

/** Types of represented entities, for polymorphic relationship with TermsAndConditionsAgreements */
export enum RepresentedEntityEnum {
  Brand = 'Brand',
  Contact = 'Contact',
  RegisteredBusiness = 'RegisteredBusiness',
}

/** Autogenerated input type of RequestDeliveryTimeChangeCP */
export type RequestDeliveryTimeChangeCpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use requestedById instead */
  contactUuid?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  orderInfo: OrderInfoInput;
  originalEventAt: Scalars['ISO8601DateTime']['input'];
  proposedEventAt: Scalars['ISO8601DateTime']['input'];
  reason: Scalars['String']['input'];
  requestedById?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of RequestOrderItemChangeCP */
export type RequestOrderItemChangeCpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use requestedById instead */
  contactUuid?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  itemChanges: Array<ItemChangeInput>;
  orderInfo: OrderInfoInput;
  reason?: InputMaybe<Scalars['String']['input']>;
  requestedById?: InputMaybe<Scalars['ID']['input']>;
};

/** States that a change request may be in */
export enum RequestStatus {
  /** accepted */
  Accepted = 'ACCEPTED',
  /** cancelled */
  Cancelled = 'CANCELLED',
  /** completed */
  Completed = 'COMPLETED',
  /** in_progress */
  InProgress = 'IN_PROGRESS',
  /** pending */
  Pending = 'PENDING',
  /** rejected */
  Rejected = 'REJECTED',
}

/** Input arguments required to resend an invoice */
export type ResendInvoiceInput = {
  body: Scalars['String']['input'];
  invoiceId: Scalars['ID']['input'];
  replyTo: Scalars['String']['input'];
  sendTo: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

/** Categories that are used to group similar sales tax codes. */
export enum SalesTaxCodeCategory {
  All = 'ALL',
  FoodItem = 'FOOD_ITEM',
  LineItem = 'LINE_ITEM',
}

/** How a thing should be taxed */
export enum SalesTaxCodeInput {
  BakeryItems = 'BAKERY_ITEMS',
  CakesAndPies = 'CAKES_AND_PIES',
  Candy = 'CANDY',
  ChipsAndSnacks = 'CHIPS_AND_SNACKS',
  CoffeeTeaMilk = 'COFFEE_TEA_MILK',
  DressingsAndCondiments = 'DRESSINGS_AND_CONDIMENTS',
  Exempt = 'EXEMPT',
  IceCream = 'ICE_CREAM',
  Miscellaneous = 'MISCELLANEOUS',
  NonSodaDrinks = 'NON_SODA_DRINKS',
  PreparedFood = 'PREPARED_FOOD',
  Sandwiches = 'SANDWICHES',
  Soda = 'SODA',
  Water = 'WATER',
}

/** Required fields used to create or update a search rank address for a caterer */
export type SearchRankAddressInput = {
  city: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

/** Error messages for why a search rank address ranking cannot be calculated */
export enum SearchRankAddressRankingError {
  AnotherStoreInBrand = 'ANOTHER_STORE_IN_BRAND',
  OutOfDeliveryArea = 'OUT_OF_DELIVERY_AREA',
}

/** Sources from where the driver initiated the self assign */
export enum SelfAssignSource {
  /** Via the flash message on Order Details */
  Alert = 'alert',
  /** Via the caterer accept flow */
  CatererAccept = 'caterer_accept',
  /** Via the food prep flow */
  FoodPrep = 'food_prep',
  /** Via the QR Code on the Order PDF */
  Qrcode = 'qrcode',
  /** Via an SMS with a link to sign up */
  Sms = 'sms',
}

/** Autogenerated input type of SetMessageStatus */
export type SetMessageStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
  reviewedById: Scalars['ID']['input'];
  reviewedByType: ActorTypes | `${ActorTypes}`;
  status: MessageStatus | `${MessageStatus}`;
};

/** The current status of whether the owner of a phone number has consented to receive certain SMS messages at that number. */
export enum SmsConsentStatusEnum {
  /**
   * The user has texted 'STOP' to an ezCater number and is blocked from receiving
   * messages through our provider (Twilio). The only way to opt back in is to send
   * 'START' to the same number.
   */
  OptedOut = 'opted_out',
  /** No consent status is known; the user still needs to be presented with the terms of service and either opt in or out. */
  Pending = 'pending',
  /** The user has accepted the terms of service and is opted in to receive messages. */
  TermsAccepted = 'terms_accepted',
  /**
   * The user did not accept the terms of service and will not receive messages.
   * They could opt back in by accepting the terms through an ezCater UI.
   */
  TermsRejected = 'terms_rejected',
}

/** Allowed values for query sorting */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** The directions that a field can be sorted in */
export enum SortDirectionTypeEnum {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum SourceNameEnum {
  /** Direct entry source */
  DirectEntry = 'direct_entry',
  /** EZO source */
  Ezo = 'ezo',
  /** Marketplace source */
  Marketplace = 'marketplace',
  /** Relish source */
  Relish = 'relish',
}

/** Attributes for editing a topsort sponsored listing campaign group */
export type SponsoredListingCampaignGroupInput = {
  /** Auto bidding goal for campaign optimization. Only applies to autobidding campaigns. */
  autoBidGoal?: InputMaybe<AutoBidGoalEnum | `${AutoBidGoalEnum}`>;
  /** Updated manual bid amount in cents. When omitted campaign will be set to autobidding strategy */
  bidAmountCents?: InputMaybe<Scalars['Int']['input']>;
  /** Updated budget amount in cents at the monthly cadence */
  budgetAmountCents?: InputMaybe<Scalars['Int']['input']>;
  /** New caterer IDs to add to the campaign group (cannot remove existing ones) */
  catererIdsToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Updated end date of campaigns */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updated name for all campaigns in the group */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Updated start date of campaigns */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Attributes for creating a topsort sponsored listing campaign */
export type SponsoredListingCampaignInput = {
  /** Auto bidding goal for campaign optimization. Only applies to autobidding campaigns. */
  autoBidGoal?: InputMaybe<AutoBidGoalEnum | `${AutoBidGoalEnum}`>;
  /** Manual id amount in cents. When omitted campaign will be set to autobidding strategy */
  bidAmountCents?: InputMaybe<Scalars['Int']['input']>;
  /** Budget amount in cents at the monthly cadence */
  budgetAmountCents: Scalars['Int']['input'];
  catererIdsToAdd: Array<Scalars['ID']['input']>;
  /** End date of campaign. When omitted campaign will last indefinitely */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Type of campaign group distribution strategy */
  groupType?: InputMaybe<GroupTypeEnum | `${GroupTypeEnum}`>;
  /** Marketing partner campaign should be attached to. When omitted will use default global caterer vendor(s) */
  marketingPartnerId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /** Start date of campaign. When omitted campaign will start immediately */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Target audience for sponsored listing campaign: new, existing, lapsed or all customers; defaults to all customers */
  targetEngagementStatuses?: InputMaybe<
    Array<TargetEngagementStatusEnum | `${TargetEngagementStatusEnum}`>
  >;
};

/** Allowed values for the review stars field */
export enum StarRating {
  Five = 'FIVE',
  Four = 'FOUR',
  One = 'ONE',
  Three = 'THREE',
  Two = 'TWO',
  Zero = 'ZERO',
}

/**
 * Allowed values for the source of the star rating. The 'mixed' value is used when
 * the aggregated data comes from both 'stars' and 'blended' sources.
 */
export enum StarRatingSource {
  Blended = 'BLENDED',
  Mixed = 'MIXED',
  Stars = 'STARS',
}

/** Arguments for filtering store performance data */
export type StorePerformanceStoresFilterInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  orderSources?: InputMaybe<Array<InputMaybe<OrderSource | `${OrderSource}`>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** The window that an order's event time must fall within in order to be included in performance data. */
  timespan?: InputMaybe<StorePerformanceTimespan | `${StorePerformanceTimespan}`>;
};

/** Allowed values for individual store performance sorting */
export enum StorePerformanceStoresSortField {
  AverageOrderValue = 'AVERAGE_ORDER_VALUE',
  Nickname = 'NICKNAME',
  TotalFood = 'TOTAL_FOOD',
  TotalOrderCount = 'TOTAL_ORDER_COUNT',
  TotalSales = 'TOTAL_SALES',
}

/** Arguments for sorting individual store performance data */
export type StorePerformanceStoresSortInput = {
  direction: SortDirection | `${SortDirection}`;
  field: StorePerformanceStoresSortField | `${StorePerformanceStoresSortField}`;
};

/** Allowed values for the order event time window used to roll up performance data. */
export enum StorePerformanceTimespan {
  Custom = 'CUSTOM',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR',
}

/** Allowed values for the marketing activities sort field */
export enum SupplierMarketingActivitySortField {
  CampaignName = 'CAMPAIGN_NAME',
  Date = 'DATE',
  Description = 'DESCRIPTION',
  Total = 'TOTAL',
  TransactionType = 'TRANSACTION_TYPE',
}

/** An input type representing a tableware choice */
export type TablewareChoiceInput = {
  id: Scalars['ID']['input'];
  isIncluded?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The user group to target for a sponsored listing campaign: new, existing, lapsed or all customers */
export enum TargetEngagementStatusEnum {
  Existing = 'existing',
  Lapsed = 'lapsed',
  New = 'new',
}

/** Possible values for tax exemption certificate status relating to a cart. */
export enum TaxExemptionCertificateStatus {
  ExpiredCertificate = 'EXPIRED_CERTIFICATE',
  NoCertificateAvailable = 'NO_CERTIFICATE_AVAILABLE',
  ValidCertificateAvailable = 'VALID_CERTIFICATE_AVAILABLE',
}

/** Allowed statuses for a tax exemption certificate */
export enum TaxExemptionStatus {
  Expired = 'expired',
  PendingApproval = 'pending_approval',
  Valid = 'valid',
}

export enum TaxFormStatus {
  Approved = 'approved',
  Expired = 'expired',
  NotStarted = 'not_started',
  Pending = 'pending',
  Submitted = 'submitted',
  SubmittedForReview = 'submitted_for_review',
  Unregistered = 'unregistered',
}

/** Allowed values for temporary closure object arguments. */
export type TemporaryClosureInput = {
  endOn: Scalars['Date']['input'];
  endTime?: InputMaybe<Scalars['TimeWithoutZone']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  markedForDestruction?: InputMaybe<Scalars['Boolean']['input']>;
  marketplace?: InputMaybe<Scalars['Boolean']['input']>;
  relish?: InputMaybe<Scalars['Boolean']['input']>;
  startOn: Scalars['Date']['input'];
  startTime?: InputMaybe<Scalars['TimeWithoutZone']['input']>;
};

/** Range of timestamps */
export type TimeRangeInput = {
  ending: Scalars['ISO8601DateTime']['input'];
  starting: Scalars['ISO8601DateTime']['input'];
};

/** Reasons a tip cannot be changed */
export enum TipImmutableReason {
  CatererDisabledTipping = 'CATERER_DISABLED_TIPPING',
  TippingExpired = 'TIPPING_EXPIRED',
}

/** Autogenerated input type of UnassignDriver */
export type UnassignDriverInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the delivery to be unassigned */
  deliveryId: Scalars['ID']['input'];
  /** ID of the driver to be unassigned */
  driverId: Scalars['ID']['input'];
};

/** Input arguments that can be updated on an existing customer */
export type UpdateCustomerInput = {
  id: Scalars['ID']['input'];
  merged?: InputMaybe<Scalars['Boolean']['input']>;
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input arguments that can be updated for existing customers */
export type UpdateCustomersInput = {
  customers: Array<UpdateCustomerInput>;
};

/** Required fields used to update stores daily capacities */
export type UpdateDailyOrderCapacities = {
  automaticTempClosure?: InputMaybe<Scalars['Boolean']['input']>;
  capacityLimitType?: InputMaybe<CapacityLimit | `${CapacityLimit}`>;
  catererIds: Array<Scalars['ID']['input']>;
  dailyOrderCapacities: Array<DailyOrderCapacity>;
};

/** Required fields used to update ezRewards for single caterer */
export type UpdateEzRewards = {
  catererId: Scalars['ID']['input'];
  level: Scalars['Int']['input'];
};

/** Input arguments required to update a house account */
export type UpdateHouseAccount = {
  address?: InputMaybe<AddressInput>;
  catererId?: InputMaybe<Scalars['ID']['input']>;
  catererIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyName: Scalars['String']['input'];
  contactFirstName: Scalars['String']['input'];
  contactLastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  houseAccountId: Scalars['String']['input'];
  paymentTermsInDays: Scalars['Int']['input'];
  phone: Scalars['String']['input'];
  taxIdNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Input arguments that can be updated for an existing lead */
export type UpdateLeadInput = {
  address?: InputMaybe<AddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  industry?: InputMaybe<IndustryTypeEnum | `${IndustryTypeEnum}`>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  merged?: InputMaybe<Scalars['Boolean']['input']>;
  omsContactId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  taxIdNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input arguments that can be updated for existing leads */
export type UpdateLeadsInput = {
  leads: Array<UpdateLeadInput>;
};

/** Input type for updating a menu */
export type UpdateMenuInputType = {
  contactName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  hasMultipleLocations: Scalars['Boolean']['input'];
  isIndividuallyPackaged?: InputMaybe<Scalars['Boolean']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  menuFiles?: InputMaybe<Array<Scalars['File']['input']>>;
  menuUpdateDestination?: InputMaybe<MenuUpdateDestination | `${MenuUpdateDestination}`>;
  menuUrl?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  specificInstructions: Scalars['String']['input'];
  storeId: Scalars['ID']['input'];
  updateNotes?: InputMaybe<Scalars['String']['input']>;
  updates: Array<Scalars['String']['input']>;
};

/** Input type for updating an order item */
export type UpdateOrderItemInputType = {
  id: Scalars['ID']['input'];
  optionInputs?: InputMaybe<Array<OrderItemOptionInputType>>;
  orderId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  vegetarianQuantity?: InputMaybe<Scalars['Int']['input']>;
};

/** Required fields used to update PPP */
export type UpdatePreferredPartnerProgram = {
  catererId: Scalars['ID']['input'];
  rate: Scalars['Int']['input'];
};

/** Valid statuses for user connection invitations */
export enum UserConnectionInvitationStatus {
  Accepted = 'ACCEPTED',
  Ignored = 'IGNORED',
  Pending = 'PENDING',
}

/** Allowed values for user industry field */
export enum UserIndustryEnum {
  Advertising = 'ADVERTISING',
  Blank = 'BLANK',
  Business = 'BUSINESS',
  Construction = 'CONSTRUCTION',
  Education = 'EDUCATION',
  Financial = 'FINANCIAL',
  Legal = 'LEGAL',
  Manufacturing = 'MANUFACTURING',
  None = 'NONE',
  Other = 'OTHER',
  Pharma = 'PHARMA',
  Pr = 'PR',
  Publishing = 'PUBLISHING',
  RealEstate = 'REAL_ESTATE',
}

/** Allowed values for user order_confirm_method field */
export enum UserOrderConfirmMethodEnum {
  Email = 'EMAIL',
  None = 'NONE',
  Txt = 'TXT',
}

/** Allowed values for user status field */
export enum UserRegistrationStatusEnum {
  CatererCreated = 'CATERER_CREATED',
  CorpError = 'CORP_ERROR',
  CorpPending = 'CORP_PENDING',
  Customer = 'CUSTOMER',
  Deleted = 'DELETED',
  Disqualified = 'DISQUALIFIED',
  Empty = 'EMPTY',
  Lead = 'LEAD',
  None = 'NONE',
  NotYetQualified = 'NOT_YET_QUALIFIED',
  Qualified = 'QUALIFIED',
  Registered = 'REGISTERED',
  SignedUp = 'SIGNED_UP',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED',
}

/** Allowed values for user_type field for Google Analytics 4 tracking */
export enum UserTypeEnum {
  Caterer = 'caterer',
  Corporate = 'corporate',
  EzOPrivateStore = 'ezO_private_store',
  Marketplace = 'marketplace',
  NoOrder = 'no_order',
}

/** Possible values for utensils selection. */
export enum UtensilsSelectionEnum {
  NotSelected = 'NOT_SELECTED',
  OptedIn = 'OPTED_IN',
  OptedOut = 'OPTED_OUT',
}

/** Allowed values for vacation period channels */
export enum VacationPeriodChannels {
  Marketplace = 'marketplace',
  Relish = 'relish',
}

/** Values for the reasons a vendor payment is being held */
export enum VendorPaymentHoldReasonEnum {
  MinimumPaymentAmount = 'MINIMUM_PAYMENT_AMOUNT',
}

/** Allowed values for the vendor payment item sort field */
export enum VendorPaymentItemSortFieldEnum {
  AddressName = 'ADDRESS_NAME',
  AddressStreet = 'ADDRESS_STREET',
  AmountPaid = 'AMOUNT_PAID',
  EventAt = 'EVENT_AT',
  OrderNumber = 'ORDER_NUMBER',
  OrderSource = 'ORDER_SOURCE',
}

/** Arguments for sorting a vendor payment's items */
export type VendorPaymentItemSortType = {
  direction: SortDirection | `${SortDirection}`;
  field: VendorPaymentItemSortFieldEnum | `${VendorPaymentItemSortFieldEnum}`;
};

/** Allowed values for vendor payment sort field */
export enum VendorPaymentSortField {
  Amount = 'AMOUNT',
  Method = 'METHOD',
  SentOn = 'SENT_ON',
}

/** Arguments for sorting vendor payments */
export type VendorPaymentSortInput = {
  direction: SortDirection | `${SortDirection}`;
  field: VendorPaymentSortField | `${VendorPaymentSortField}`;
};

export enum Join__Graph {
  CustomerManagement = 'CUSTOMER_MANAGEMENT',
  DeliveryManagement = 'DELIVERY_MANAGEMENT',
  DeliveryManagementDriver = 'DELIVERY_MANAGEMENT_DRIVER',
  DirectConnect = 'DIRECT_CONNECT',
  Management = 'MANAGEMENT',
}

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY',
}
